function _mergeNamespaces(n, m) {
    m.forEach(function (e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    });
    return Object.freeze(n);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var fetch_umd = {exports: {}};

(function (module, exports) {
(function (global, factory) {
  factory(exports) ;
}(commonjsGlobal, (function (exports) {
  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
}(fetch_umd, fetch_umd.exports));

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

let logDisabled_ = true;
let deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion$1(uastring, expr, pos) {
  const match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  const proto = window.RTCPeerConnection.prototype;
  const nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    const wrappedCallback = (e) => {
      const modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        if (cb.handleEvent) {
          cb.handleEvent(modifiedEvent);
        } else {
          cb(modifiedEvent);
        }
      }
    };
    this._eventMap = this._eventMap || {};
    if (!this._eventMap[eventNameToWrap]) {
      this._eventMap[eventNameToWrap] = new Map();
    }
    this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
    return nativeAddEventListener.apply(this, [nativeEventName,
      wrappedCallback]);
  };

  const nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap
        || !this._eventMap[eventNameToWrap]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    if (!this._eventMap[eventNameToWrap].has(cb)) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
    this._eventMap[eventNameToWrap].delete(cb);
    if (this._eventMap[eventNameToWrap].size === 0) {
      delete this._eventMap[eventNameToWrap];
    }
    if (Object.keys(this._eventMap).length === 0) {
      delete this._eventMap;
    }
    return nativeRemoveEventListener.apply(this, [nativeEventName,
      unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get() {
      return this['_on' + eventNameToWrap];
    },
    set(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap] = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
}

function disableLog(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool +
        '. Please use a boolean.');
  }
  logDisabled_ = bool;
  return (bool) ? 'adapter.js logging disabled' :
      'adapter.js logging enabled';
}

/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */
function disableWarnings(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool +
        '. Please use a boolean.');
  }
  deprecationWarnings_ = !bool;
  return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}

function log() {
  if (typeof window === 'object') {
    if (logDisabled_) {
      return;
    }
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
      console.log.apply(console, arguments);
    }
  }
}

/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */
function deprecated(oldMethod, newMethod) {
  if (!deprecationWarnings_) {
    return;
  }
  console.warn(oldMethod + ' is deprecated, please use ' + newMethod +
      ' instead.');
}

/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */
function detectBrowser(window) {
  // Returned result object.
  const result = {browser: null, version: null};

  // Fail early if it's not a browser
  if (typeof window === 'undefined' || !window.navigator) {
    result.browser = 'Not a browser.';
    return result;
  }

  const {navigator} = window;

  if (navigator.mozGetUserMedia) { // Firefox.
    result.browser = 'firefox';
    result.version = extractVersion$1(navigator.userAgent,
        /Firefox\/(\d+)\./, 1);
  } else if (navigator.webkitGetUserMedia ||
      (window.isSecureContext === false && window.webkitRTCPeerConnection &&
       !window.RTCIceGatherer)) {
    // Chrome, Chromium, Webview, Opera.
    // Version matches Chrome/WebRTC version.
    // Chrome 74 removed webkitGetUserMedia on http as well so we need the
    // more complicated fallback to webkitRTCPeerConnection.
    result.browser = 'chrome';
    result.version = extractVersion$1(navigator.userAgent,
        /Chrom(e|ium)\/(\d+)\./, 2);
  } else if (window.RTCPeerConnection &&
      navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) { // Safari.
    result.browser = 'safari';
    result.version = extractVersion$1(navigator.userAgent,
        /AppleWebKit\/(\d+)\./, 1);
    result.supportsUnifiedPlan = window.RTCRtpTransceiver &&
        'currentDirection' in window.RTCRtpTransceiver.prototype;
  } else { // Default fallthrough: not supported.
    result.browser = 'Not a supported browser.';
    return result;
  }

  return result;
}

/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */
function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}

/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */
function compactObject(data) {
  if (!isObject(data)) {
    return data;
  }

  return Object.keys(data).reduce(function(accumulator, key) {
    const isObj = isObject(data[key]);
    const value = isObj ? compactObject(data[key]) : data[key];
    const isEmptyObject = isObj && !Object.keys(value).length;
    if (value === undefined || isEmptyObject) {
      return accumulator;
    }
    return Object.assign(accumulator, {[key]: value});
  }, {});
}

/* iterates the stats graph recursively. */
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(name => {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(id => {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}

/* filter getStats for a sender/receiver track. */
function filterStats(result, track, outbound) {
  const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  const filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  const trackStats = [];
  result.forEach(value => {
    if (value.type === 'track' &&
        value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(trackStat => {
    result.forEach(stats => {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
const logging = log;

function shimGetUserMedia$2(window, browserDetails) {
  const navigator = window && window.navigator;

  if (!navigator.mediaDevices) {
    return;
  }

  const constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    const cc = {};
    Object.keys(c).forEach(key => {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      const r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      const oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        let oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(mix => {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  const shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      const remap = function(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      let face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});
      const getSupportedFacingModeLies = browserDetails.version < 66;

      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode &&
            !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        let matches;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices()
          .then(devices => {
            devices = devices.filter(d => d.kind === 'videoinput');
            let dev = devices.find(d => matches.some(match =>
              d.label.toLowerCase().includes(match)));
            if (!dev && devices.length && matches.includes('back')) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? {exact: dev.deviceId} :
                                                        {ideal: dev.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  const shimError_ = function(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  const getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, c => {
      navigator.webkitGetUserMedia(c, onSuccess, e => {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };
  navigator.getUserMedia = getUserMedia_.bind(navigator);

  // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
  // function which returns a Promise, it does not accept spec-style
  // constraints.
  if (navigator.mediaDevices.getUserMedia) {
    const origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, c => origGetUserMedia(c).then(stream => {
        if (c.audio && !stream.getAudioTracks().length ||
            c.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach(track => {
            track.stop();
          });
          throw new DOMException('', 'NotFoundError');
        }
        return stream;
      }, e => Promise.reject(shimError_(e))));
    };
  }
}

/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
function shimGetDisplayMedia$1(window, getSourceId) {
  if (window.navigator.mediaDevices &&
    'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!(window.navigator.mediaDevices)) {
    return;
  }
  // getSourceId is a function that returns a promise resolving with
  // the sourceId of the screen/window/tab to be shared.
  if (typeof getSourceId !== 'function') {
    console.error('shimGetDisplayMedia: getSourceId argument is not ' +
        'a function');
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia =
    function getDisplayMedia(constraints) {
      return getSourceId(constraints)
        .then(sourceId => {
          const widthSpecified = constraints.video && constraints.video.width;
          const heightSpecified = constraints.video &&
            constraints.video.height;
          const frameRateSpecified = constraints.video &&
            constraints.video.frameRate;
          constraints.video = {
            mandatory: {
              chromeMediaSource: 'desktop',
              chromeMediaSourceId: sourceId,
              maxFrameRate: frameRateSpecified || 3
            }
          };
          if (widthSpecified) {
            constraints.video.mandatory.maxWidth = widthSpecified;
          }
          if (heightSpecified) {
            constraints.video.mandatory.maxHeight = heightSpecified;
          }
          return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimMediaStream(window) {
  window.MediaStream = window.MediaStream || window.webkitMediaStream;
}

function shimOnTrack$1(window) {
  if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
      window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
      get() {
        return this._ontrack;
      },
      set(f) {
        if (this._ontrack) {
          this.removeEventListener('track', this._ontrack);
        }
        this.addEventListener('track', this._ontrack = f);
      },
      enumerable: true,
      configurable: true
    });
    const origSetRemoteDescription =
        window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription =
      function setRemoteDescription() {
        if (!this._ontrackpoly) {
          this._ontrackpoly = (e) => {
            // onaddstream does not fire when a track is added to an existing
            // stream. But stream.onaddtrack is implemented so we use that.
            e.stream.addEventListener('addtrack', te => {
              let receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = this.getReceivers()
                  .find(r => r.track && r.track.id === te.track.id);
              } else {
                receiver = {track: te.track};
              }

              const event = new Event('track');
              event.track = te.track;
              event.receiver = receiver;
              event.transceiver = {receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(track => {
              let receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = this.getReceivers()
                  .find(r => r.track && r.track.id === track.id);
              } else {
                receiver = {track};
              }
              const event = new Event('track');
              event.track = track;
              event.receiver = receiver;
              event.transceiver = {receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            });
          };
          this.addEventListener('addstream', this._ontrackpoly);
        }
        return origSetRemoteDescription.apply(this, arguments);
      };
  } else {
    // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    wrapPeerConnectionEvent(window, 'track', e => {
      if (!e.transceiver) {
        Object.defineProperty(e, 'transceiver',
          {value: {receiver: e.receiver}});
      }
      return e;
    });
  }
}

function shimGetSendersWithDtmf(window) {
  // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
  if (typeof window === 'object' && window.RTCPeerConnection &&
      !('getSenders' in window.RTCPeerConnection.prototype) &&
      'createDTMFSender' in window.RTCPeerConnection.prototype) {
    const shimSenderWithDtmf = function(pc, track) {
      return {
        track,
        get dtmf() {
          if (this._dtmf === undefined) {
            if (track.kind === 'audio') {
              this._dtmf = pc.createDTMFSender(track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        },
        _pc: pc
      };
    };

    // augment addTrack when getSenders is not available.
    if (!window.RTCPeerConnection.prototype.getSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        this._senders = this._senders || [];
        return this._senders.slice(); // return a copy of the internal state.
      };
      const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addTrack =
        function addTrack(track, stream) {
          let sender = origAddTrack.apply(this, arguments);
          if (!sender) {
            sender = shimSenderWithDtmf(this, track);
            this._senders.push(sender);
          }
          return sender;
        };

      const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
      window.RTCPeerConnection.prototype.removeTrack =
        function removeTrack(sender) {
          origRemoveTrack.apply(this, arguments);
          const idx = this._senders.indexOf(sender);
          if (idx !== -1) {
            this._senders.splice(idx, 1);
          }
        };
    }
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      this._senders = this._senders || [];
      origAddStream.apply(this, [stream]);
      stream.getTracks().forEach(track => {
        this._senders.push(shimSenderWithDtmf(this, track));
      });
    };

    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream =
      function removeStream(stream) {
        this._senders = this._senders || [];
        origRemoveStream.apply(this, [stream]);

        stream.getTracks().forEach(track => {
          const sender = this._senders.find(s => s.track === track);
          if (sender) { // remove sender
            this._senders.splice(this._senders.indexOf(sender), 1);
          }
        });
      };
  } else if (typeof window === 'object' && window.RTCPeerConnection &&
             'getSenders' in window.RTCPeerConnection.prototype &&
             'createDTMFSender' in window.RTCPeerConnection.prototype &&
             window.RTCRtpSender &&
             !('dtmf' in window.RTCRtpSender.prototype)) {
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      const senders = origGetSenders.apply(this, []);
      senders.forEach(sender => sender._pc = this);
      return senders;
    };

    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = this._pc.createDTMFSender(this.track);
          } else {
            this._dtmf = null;
          }
        }
        return this._dtmf;
      }
    });
  }
}

function shimGetStats(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  const origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    const [selector, onSucc, onErr] = arguments;

    // If selector is a function then we are in the old style stats so just
    // pass back the original getStats format to avoid breaking old users.
    if (arguments.length > 0 && typeof selector === 'function') {
      return origGetStats.apply(this, arguments);
    }

    // When spec-style getStats is supported, return those when called with
    // either no arguments or the selector argument is null.
    if (origGetStats.length === 0 && (arguments.length === 0 ||
        typeof selector !== 'function')) {
      return origGetStats.apply(this, []);
    }

    const fixChromeStats_ = function(response) {
      const standardReport = {};
      const reports = response.result();
      reports.forEach(report => {
        const standardStats = {
          id: report.id,
          timestamp: report.timestamp,
          type: {
            localcandidate: 'local-candidate',
            remotecandidate: 'remote-candidate'
          }[report.type] || report.type
        };
        report.names().forEach(name => {
          standardStats[name] = report.stat(name);
        });
        standardReport[standardStats.id] = standardStats;
      });

      return standardReport;
    };

    // shim getStats with maplike support
    const makeMapStats = function(stats) {
      return new Map(Object.keys(stats).map(key => [key, stats[key]]));
    };

    if (arguments.length >= 2) {
      const successCallbackWrapper_ = function(response) {
        onSucc(makeMapStats(fixChromeStats_(response)));
      };

      return origGetStats.apply(this, [successCallbackWrapper_,
        selector]);
    }

    // promise-support
    return new Promise((resolve, reject) => {
      origGetStats.apply(this, [
        function(response) {
          resolve(makeMapStats(fixChromeStats_(response)));
        }, reject]);
    }).then(onSucc, onErr);
  };
}

function shimSenderReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection &&
      window.RTCRtpSender && window.RTCRtpReceiver)) {
    return;
  }

  // shim sender stats.
  if (!('getStats' in window.RTCRtpSender.prototype)) {
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach(sender => sender._pc = this);
        return senders;
      };
    }

    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function getStats() {
      const sender = this;
      return this._pc.getStats().then(result =>
        /* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */
        filterStats(result, sender.track, true));
    };
  }

  // shim receiver stats.
  if (!('getStats' in window.RTCRtpReceiver.prototype)) {
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers =
        function getReceivers() {
          const receivers = origGetReceivers.apply(this, []);
          receivers.forEach(receiver => receiver._pc = this);
          return receivers;
        };
    }
    wrapPeerConnectionEvent(window, 'track', e => {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
      const receiver = this;
      return this._pc.getStats().then(result =>
        filterStats(result, receiver.track, false));
    };
  }

  if (!('getStats' in window.RTCRtpSender.prototype &&
      'getStats' in window.RTCRtpReceiver.prototype)) {
    return;
  }

  // shim RTCPeerConnection.getStats(track).
  const origGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    if (arguments.length > 0 &&
        arguments[0] instanceof window.MediaStreamTrack) {
      const track = arguments[0];
      let sender;
      let receiver;
      let err;
      this.getSenders().forEach(s => {
        if (s.track === track) {
          if (sender) {
            err = true;
          } else {
            sender = s;
          }
        }
      });
      this.getReceivers().forEach(r => {
        if (r.track === track) {
          if (receiver) {
            err = true;
          } else {
            receiver = r;
          }
        }
        return r.track === track;
      });
      if (err || (sender && receiver)) {
        return Promise.reject(new DOMException(
          'There are more than one sender or receiver for the track.',
          'InvalidAccessError'));
      } else if (sender) {
        return sender.getStats();
      } else if (receiver) {
        return receiver.getStats();
      }
      return Promise.reject(new DOMException(
        'There is no sender or receiver for the track.',
        'InvalidAccessError'));
    }
    return origGetStats.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrackWithNative(window) {
  // shim addTrack/removeTrack with native variants in order to make
  // the interactions with legacy getLocalStreams behave as in other browsers.
  // Keeps a mapping stream.id => [stream, rtpsenders...]
  window.RTCPeerConnection.prototype.getLocalStreams =
    function getLocalStreams() {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      return Object.keys(this._shimmedLocalStreams)
        .map(streamId => this._shimmedLocalStreams[streamId][0]);
    };

  const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  window.RTCPeerConnection.prototype.addTrack =
    function addTrack(track, stream) {
      if (!stream) {
        return origAddTrack.apply(this, arguments);
      }
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      const sender = origAddTrack.apply(this, arguments);
      if (!this._shimmedLocalStreams[stream.id]) {
        this._shimmedLocalStreams[stream.id] = [stream, sender];
      } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
        this._shimmedLocalStreams[stream.id].push(sender);
      }
      return sender;
    };

  const origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    stream.getTracks().forEach(track => {
      const alreadyExists = this.getSenders().find(s => s.track === track);
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }
    });
    const existingSenders = this.getSenders();
    origAddStream.apply(this, arguments);
    const newSenders = this.getSenders()
      .filter(newSender => existingSenders.indexOf(newSender) === -1);
    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
  };

  const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream =
    function removeStream(stream) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      delete this._shimmedLocalStreams[stream.id];
      return origRemoveStream.apply(this, arguments);
    };

  const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
  window.RTCPeerConnection.prototype.removeTrack =
    function removeTrack(sender) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      if (sender) {
        Object.keys(this._shimmedLocalStreams).forEach(streamId => {
          const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
          if (idx !== -1) {
            this._shimmedLocalStreams[streamId].splice(idx, 1);
          }
          if (this._shimmedLocalStreams[streamId].length === 1) {
            delete this._shimmedLocalStreams[streamId];
          }
        });
      }
      return origRemoveTrack.apply(this, arguments);
    };
}

function shimAddTrackRemoveTrack(window, browserDetails) {
  if (!window.RTCPeerConnection) {
    return;
  }
  // shim addTrack and removeTrack.
  if (window.RTCPeerConnection.prototype.addTrack &&
      browserDetails.version >= 65) {
    return shimAddTrackRemoveTrackWithNative(window);
  }

  // also shim pc.getLocalStreams when addTrack is shimmed
  // to return the original streams.
  const origGetLocalStreams = window.RTCPeerConnection.prototype
      .getLocalStreams;
  window.RTCPeerConnection.prototype.getLocalStreams =
    function getLocalStreams() {
      const nativeStreams = origGetLocalStreams.apply(this);
      this._reverseStreams = this._reverseStreams || {};
      return nativeStreams.map(stream => this._reverseStreams[stream.id]);
    };

  const origAddStream = window.RTCPeerConnection.prototype.addStream;
  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};

    stream.getTracks().forEach(track => {
      const alreadyExists = this.getSenders().find(s => s.track === track);
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }
    });
    // Add identity mapping for consistency with addTrack.
    // Unless this is being used with a stream from addTrack.
    if (!this._reverseStreams[stream.id]) {
      const newStream = new window.MediaStream(stream.getTracks());
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      stream = newStream;
    }
    origAddStream.apply(this, [stream]);
  };

  const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
  window.RTCPeerConnection.prototype.removeStream =
    function removeStream(stream) {
      this._streams = this._streams || {};
      this._reverseStreams = this._reverseStreams || {};

      origRemoveStream.apply(this, [(this._streams[stream.id] || stream)]);
      delete this._reverseStreams[(this._streams[stream.id] ?
          this._streams[stream.id].id : stream.id)];
      delete this._streams[stream.id];
    };

  window.RTCPeerConnection.prototype.addTrack =
    function addTrack(track, stream) {
      if (this.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      const streams = [].slice.call(arguments, 1);
      if (streams.length !== 1 ||
          !streams[0].getTracks().find(t => t === track)) {
        // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException(
          'The adapter.js addTrack polyfill only supports a single ' +
          ' stream which is associated with the specified track.',
          'NotSupportedError');
      }

      const alreadyExists = this.getSenders().find(s => s.track === track);
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }

      this._streams = this._streams || {};
      this._reverseStreams = this._reverseStreams || {};
      const oldStream = this._streams[stream.id];
      if (oldStream) {
        // this is using odd Chrome behaviour, use with caution:
        // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
        // Note: we rely on the high-level addTrack/dtmf shim to
        // create the sender with a dtmf sender.
        oldStream.addTrack(track);

        // Trigger ONN async.
        Promise.resolve().then(() => {
          this.dispatchEvent(new Event('negotiationneeded'));
        });
      } else {
        const newStream = new window.MediaStream([track]);
        this._streams[stream.id] = newStream;
        this._reverseStreams[newStream.id] = stream;
        this.addStream(newStream);
      }
      return this.getSenders().find(s => s.track === track);
    };

  // replace the internal stream id with the external one and
  // vice versa.
  function replaceInternalStreamId(pc, description) {
    let sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(internalId => {
      const externalStream = pc._reverseStreams[internalId];
      const internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(internalStream.id, 'g'),
          externalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp
    });
  }
  function replaceExternalStreamId(pc, description) {
    let sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(internalId => {
      const externalStream = pc._reverseStreams[internalId];
      const internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(externalStream.id, 'g'),
          internalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp
    });
  }
  ['createOffer', 'createAnswer'].forEach(function(method) {
    const nativeMethod = window.RTCPeerConnection.prototype[method];
    const methodObj = {[method]() {
      const args = arguments;
      const isLegacyCall = arguments.length &&
          typeof arguments[0] === 'function';
      if (isLegacyCall) {
        return nativeMethod.apply(this, [
          (description) => {
            const desc = replaceInternalStreamId(this, description);
            args[0].apply(null, [desc]);
          },
          (err) => {
            if (args[1]) {
              args[1].apply(null, err);
            }
          }, arguments[2]
        ]);
      }
      return nativeMethod.apply(this, arguments)
      .then(description => replaceInternalStreamId(this, description));
    }};
    window.RTCPeerConnection.prototype[method] = methodObj[method];
  });

  const origSetLocalDescription =
      window.RTCPeerConnection.prototype.setLocalDescription;
  window.RTCPeerConnection.prototype.setLocalDescription =
    function setLocalDescription() {
      if (!arguments.length || !arguments[0].type) {
        return origSetLocalDescription.apply(this, arguments);
      }
      arguments[0] = replaceExternalStreamId(this, arguments[0]);
      return origSetLocalDescription.apply(this, arguments);
    };

  // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

  const origLocalDescription = Object.getOwnPropertyDescriptor(
      window.RTCPeerConnection.prototype, 'localDescription');
  Object.defineProperty(window.RTCPeerConnection.prototype,
      'localDescription', {
        get() {
          const description = origLocalDescription.get.apply(this);
          if (description.type === '') {
            return description;
          }
          return replaceInternalStreamId(this, description);
        }
      });

  window.RTCPeerConnection.prototype.removeTrack =
    function removeTrack(sender) {
      if (this.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      // We can not yet check for sender instanceof RTCRtpSender
      // since we shim RTPSender. So we check if sender._pc is set.
      if (!sender._pc) {
        throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' +
            'does not implement interface RTCRtpSender.', 'TypeError');
      }
      const isLocal = sender._pc === this;
      if (!isLocal) {
        throw new DOMException('Sender was not created by this connection.',
            'InvalidAccessError');
      }

      // Search for the native stream the senders track belongs to.
      this._streams = this._streams || {};
      let stream;
      Object.keys(this._streams).forEach(streamid => {
        const hasTrack = this._streams[streamid].getTracks()
          .find(track => sender.track === track);
        if (hasTrack) {
          stream = this._streams[streamid];
        }
      });

      if (stream) {
        if (stream.getTracks().length === 1) {
          // if this is the last track of the stream, remove the stream. This
          // takes care of any shimmed _senders.
          this.removeStream(this._reverseStreams[stream.id]);
        } else {
          // relying on the same odd chrome behaviour as above.
          stream.removeTrack(sender.track);
        }
        this.dispatchEvent(new Event('negotiationneeded'));
      }
    };
}

function shimPeerConnection$1(window, browserDetails) {
  if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
  }
  if (!window.RTCPeerConnection) {
    return;
  }

  // shim implicit creation of RTCSessionDescription/RTCIceCandidate
  if (browserDetails.version < 53) {
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          const nativeMethod = window.RTCPeerConnection.prototype[method];
          const methodObj = {[method]() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          }};
          window.RTCPeerConnection.prototype[method] = methodObj[method];
        });
  }
}

// Attempt to fix ONN in plan-b mode.
function fixNegotiationNeeded(window, browserDetails) {
  wrapPeerConnectionEvent(window, 'negotiationneeded', e => {
    const pc = e.target;
    if (browserDetails.version < 72 || (pc.getConfiguration &&
        pc.getConfiguration().sdpSemantics === 'plan-b')) {
      if (pc.signalingState !== 'stable') {
        return;
      }
    }
    return e;
  });
}

var chromeShim = /*#__PURE__*/Object.freeze({
    __proto__: null,
    shimMediaStream: shimMediaStream,
    shimOnTrack: shimOnTrack$1,
    shimGetSendersWithDtmf: shimGetSendersWithDtmf,
    shimGetStats: shimGetStats,
    shimSenderReceiverGetStats: shimSenderReceiverGetStats,
    shimAddTrackRemoveTrackWithNative: shimAddTrackRemoveTrackWithNative,
    shimAddTrackRemoveTrack: shimAddTrackRemoveTrack,
    shimPeerConnection: shimPeerConnection$1,
    fixNegotiationNeeded: fixNegotiationNeeded,
    shimGetUserMedia: shimGetUserMedia$2,
    shimGetDisplayMedia: shimGetDisplayMedia$1
});

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimGetUserMedia$1(window, browserDetails) {
  const navigator = window && window.navigator;
  const MediaStreamTrack = window && window.MediaStreamTrack;

  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    deprecated('navigator.getUserMedia',
        'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };

  if (!(browserDetails.version > 55 &&
      'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    const remap = function(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        const obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      const nativeApplyConstraints =
        MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
}

/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimGetDisplayMedia(window, preferredMediaSource) {
  if (window.navigator.mediaDevices &&
    'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }
  if (!(window.navigator.mediaDevices)) {
    return;
  }
  window.navigator.mediaDevices.getDisplayMedia =
    function getDisplayMedia(constraints) {
      if (!(constraints && constraints.video)) {
        const err = new DOMException('getDisplayMedia without video ' +
            'constraints is undefined');
        err.name = 'NotFoundError';
        // from https://heycam.github.io/webidl/#idl-DOMException-error-names
        err.code = 8;
        return Promise.reject(err);
      }
      if (constraints.video === true) {
        constraints.video = {mediaSource: preferredMediaSource};
      } else {
        constraints.video.mediaSource = preferredMediaSource;
      }
      return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimOnTrack(window) {
  if (typeof window === 'object' && window.RTCTrackEvent &&
      ('receiver' in window.RTCTrackEvent.prototype) &&
      !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get() {
        return {receiver: this.receiver};
      }
    });
  }
}

function shimPeerConnection(window, browserDetails) {
  if (typeof window !== 'object' ||
      !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
    return; // probably media.peerconnection.enabled=false in about:config
  }
  if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
  }

  if (browserDetails.version < 53) {
    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          const nativeMethod = window.RTCPeerConnection.prototype[method];
          const methodObj = {[method]() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          }};
          window.RTCPeerConnection.prototype[method] = methodObj[method];
        });
  }

  const modernStatsTypes = {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  };

  const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
  window.RTCPeerConnection.prototype.getStats = function getStats() {
    const [selector, onSucc, onErr] = arguments;
    return nativeGetStats.apply(this, [selector || null])
      .then(stats => {
        if (browserDetails.version < 53 && !onSucc) {
          // Shim only promise getStats with spec-hyphens in type names
          // Leave callback version alone; misc old uses of forEach before Map
          try {
            stats.forEach(stat => {
              stat.type = modernStatsTypes[stat.type] || stat.type;
            });
          } catch (e) {
            if (e.name !== 'TypeError') {
              throw e;
            }
            // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
            stats.forEach((stat, i) => {
              stats.set(i, Object.assign({}, stat, {
                type: modernStatsTypes[stat.type] || stat.type
              }));
            });
          }
        }
        return stats;
      })
      .then(onSucc, onErr);
  };
}

function shimSenderGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection &&
      window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
    return;
  }
  const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
  if (origGetSenders) {
    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      const senders = origGetSenders.apply(this, []);
      senders.forEach(sender => sender._pc = this);
      return senders;
    };
  }

  const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
  if (origAddTrack) {
    window.RTCPeerConnection.prototype.addTrack = function addTrack() {
      const sender = origAddTrack.apply(this, arguments);
      sender._pc = this;
      return sender;
    };
  }
  window.RTCRtpSender.prototype.getStats = function getStats() {
    return this.track ? this._pc.getStats(this.track) :
        Promise.resolve(new Map());
  };
}

function shimReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection &&
      window.RTCRtpSender)) {
    return;
  }
  if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
    return;
  }
  const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
  if (origGetReceivers) {
    window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
      const receivers = origGetReceivers.apply(this, []);
      receivers.forEach(receiver => receiver._pc = this);
      return receivers;
    };
  }
  wrapPeerConnectionEvent(window, 'track', e => {
    e.receiver._pc = e.srcElement;
    return e;
  });
  window.RTCRtpReceiver.prototype.getStats = function getStats() {
    return this._pc.getStats(this.track);
  };
}

function shimRemoveStream(window) {
  if (!window.RTCPeerConnection ||
      'removeStream' in window.RTCPeerConnection.prototype) {
    return;
  }
  window.RTCPeerConnection.prototype.removeStream =
    function removeStream(stream) {
      deprecated('removeStream', 'removeTrack');
      this.getSenders().forEach(sender => {
        if (sender.track && stream.getTracks().includes(sender.track)) {
          this.removeTrack(sender);
        }
      });
    };
}

function shimRTCDataChannel(window) {
  // rename DataChannel to RTCDataChannel (native fix in FF60):
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
  if (window.DataChannel && !window.RTCDataChannel) {
    window.RTCDataChannel = window.DataChannel;
  }
}

function shimAddTransceiver(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
  if (origAddTransceiver) {
    window.RTCPeerConnection.prototype.addTransceiver =
      function addTransceiver() {
        this.setParametersPromises = [];
        const initParameters = arguments[1];
        const shouldPerformCheck = initParameters &&
                                  'sendEncodings' in initParameters;
        if (shouldPerformCheck) {
          // If sendEncodings params are provided, validate grammar
          initParameters.sendEncodings.forEach((encodingParam) => {
            if ('rid' in encodingParam) {
              const ridRegex = /^[a-z0-9]{0,16}$/i;
              if (!ridRegex.test(encodingParam.rid)) {
                throw new TypeError('Invalid RID value provided.');
              }
            }
            if ('scaleResolutionDownBy' in encodingParam) {
              if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) {
                throw new RangeError('scale_resolution_down_by must be >= 1.0');
              }
            }
            if ('maxFramerate' in encodingParam) {
              if (!(parseFloat(encodingParam.maxFramerate) >= 0)) {
                throw new RangeError('max_framerate must be >= 0.0');
              }
            }
          });
        }
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
          // Check if the init options were applied. If not we do this in an
          // asynchronous way and save the promise reference in a global object.
          // This is an ugly hack, but at the same time is way more robust than
          // checking the sender parameters before and after the createOffer
          // Also note that after the createoffer we are not 100% sure that
          // the params were asynchronously applied so we might miss the
          // opportunity to recreate offer.
          const {sender} = transceiver;
          const params = sender.getParameters();
          if (!('encodings' in params) ||
              // Avoid being fooled by patched getParameters() below.
              (params.encodings.length === 1 &&
               Object.keys(params.encodings[0]).length === 0)) {
            params.encodings = initParameters.sendEncodings;
            sender.sendEncodings = initParameters.sendEncodings;
            this.setParametersPromises.push(sender.setParameters(params)
              .then(() => {
                delete sender.sendEncodings;
              }).catch(() => {
                delete sender.sendEncodings;
              })
            );
          }
        }
        return transceiver;
      };
  }
}

function shimGetParameters(window) {
  if (!(typeof window === 'object' && window.RTCRtpSender)) {
    return;
  }
  const origGetParameters = window.RTCRtpSender.prototype.getParameters;
  if (origGetParameters) {
    window.RTCRtpSender.prototype.getParameters =
      function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) {
          params.encodings = [].concat(this.sendEncodings || [{}]);
        }
        return params;
      };
  }
}

function shimCreateOffer(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
  window.RTCPeerConnection.prototype.createOffer = function createOffer() {
    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises)
      .then(() => {
        return origCreateOffer.apply(this, arguments);
      })
      .finally(() => {
        this.setParametersPromises = [];
      });
    }
    return origCreateOffer.apply(this, arguments);
  };
}

function shimCreateAnswer(window) {
  // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
  // Firefox ignores the init sendEncodings options passed to addTransceiver
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
  if (!(typeof window === 'object' && window.RTCPeerConnection)) {
    return;
  }
  const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
  window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises)
      .then(() => {
        return origCreateAnswer.apply(this, arguments);
      })
      .finally(() => {
        this.setParametersPromises = [];
      });
    }
    return origCreateAnswer.apply(this, arguments);
  };
}

var firefoxShim = /*#__PURE__*/Object.freeze({
    __proto__: null,
    shimOnTrack: shimOnTrack,
    shimPeerConnection: shimPeerConnection,
    shimSenderGetStats: shimSenderGetStats,
    shimReceiverGetStats: shimReceiverGetStats,
    shimRemoveStream: shimRemoveStream,
    shimRTCDataChannel: shimRTCDataChannel,
    shimAddTransceiver: shimAddTransceiver,
    shimGetParameters: shimGetParameters,
    shimCreateOffer: shimCreateOffer,
    shimCreateAnswer: shimCreateAnswer,
    shimGetUserMedia: shimGetUserMedia$1,
    shimGetDisplayMedia: shimGetDisplayMedia
});

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimLocalStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getLocalStreams =
      function getLocalStreams() {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        return this._localStreams;
      };
  }
  if (!('addStream' in window.RTCPeerConnection.prototype)) {
    const _addTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      if (!this._localStreams.includes(stream)) {
        this._localStreams.push(stream);
      }
      // Try to emulate Chrome's behaviour of adding in audio-video order.
      // Safari orders by track id.
      stream.getAudioTracks().forEach(track => _addTrack.call(this, track,
        stream));
      stream.getVideoTracks().forEach(track => _addTrack.call(this, track,
        stream));
    };

    window.RTCPeerConnection.prototype.addTrack =
      function addTrack(track, ...streams) {
        if (streams) {
          streams.forEach((stream) => {
            if (!this._localStreams) {
              this._localStreams = [stream];
            } else if (!this._localStreams.includes(stream)) {
              this._localStreams.push(stream);
            }
          });
        }
        return _addTrack.apply(this, arguments);
      };
  }
  if (!('removeStream' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.removeStream =
      function removeStream(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        const index = this._localStreams.indexOf(stream);
        if (index === -1) {
          return;
        }
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach(sender => {
          if (tracks.includes(sender.track)) {
            this.removeTrack(sender);
          }
        });
      };
  }
}

function shimRemoteStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getRemoteStreams =
      function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
      };
  }
  if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
      get() {
        return this._onaddstream;
      },
      set(f) {
        if (this._onaddstream) {
          this.removeEventListener('addstream', this._onaddstream);
          this.removeEventListener('track', this._onaddstreampoly);
        }
        this.addEventListener('addstream', this._onaddstream = f);
        this.addEventListener('track', this._onaddstreampoly = (e) => {
          e.streams.forEach(stream => {
            if (!this._remoteStreams) {
              this._remoteStreams = [];
            }
            if (this._remoteStreams.includes(stream)) {
              return;
            }
            this._remoteStreams.push(stream);
            const event = new Event('addstream');
            event.stream = stream;
            this.dispatchEvent(event);
          });
        });
      }
    });
    const origSetRemoteDescription =
      window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription =
      function setRemoteDescription() {
        const pc = this;
        if (!this._onaddstreampoly) {
          this.addEventListener('track', this._onaddstreampoly = function(e) {
            e.streams.forEach(stream => {
              if (!pc._remoteStreams) {
                pc._remoteStreams = [];
              }
              if (pc._remoteStreams.indexOf(stream) >= 0) {
                return;
              }
              pc._remoteStreams.push(stream);
              const event = new Event('addstream');
              event.stream = stream;
              pc.dispatchEvent(event);
            });
          });
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
  }
}

function shimCallbacksAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }
  const prototype = window.RTCPeerConnection.prototype;
  const origCreateOffer = prototype.createOffer;
  const origCreateAnswer = prototype.createAnswer;
  const setLocalDescription = prototype.setLocalDescription;
  const setRemoteDescription = prototype.setRemoteDescription;
  const addIceCandidate = prototype.addIceCandidate;

  prototype.createOffer =
    function createOffer(successCallback, failureCallback) {
      const options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      const promise = origCreateOffer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

  prototype.createAnswer =
    function createAnswer(successCallback, failureCallback) {
      const options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      const promise = origCreateAnswer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

  let withCallback = function(description, successCallback, failureCallback) {
    const promise = setLocalDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setLocalDescription = withCallback;

  withCallback = function(description, successCallback, failureCallback) {
    const promise = setRemoteDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setRemoteDescription = withCallback;

  withCallback = function(candidate, successCallback, failureCallback) {
    const promise = addIceCandidate.apply(this, [candidate]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.addIceCandidate = withCallback;
}

function shimGetUserMedia(window) {
  const navigator = window && window.navigator;

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // shim not needed in Safari 12.1
    const mediaDevices = navigator.mediaDevices;
    const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
    navigator.mediaDevices.getUserMedia = (constraints) => {
      return _getUserMedia(shimConstraints(constraints));
    };
  }

  if (!navigator.getUserMedia && navigator.mediaDevices &&
    navigator.mediaDevices.getUserMedia) {
    navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
      navigator.mediaDevices.getUserMedia(constraints)
      .then(cb, errcb);
    }.bind(navigator);
  }
}

function shimConstraints(constraints) {
  if (constraints && constraints.video !== undefined) {
    return Object.assign({},
      constraints,
      {video: compactObject(constraints.video)}
    );
  }

  return constraints;
}

function shimRTCIceServerUrls(window) {
  if (!window.RTCPeerConnection) {
    return;
  }
  // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
  const OrigPeerConnection = window.RTCPeerConnection;
  window.RTCPeerConnection =
    function RTCPeerConnection(pcConfig, pcConstraints) {
      if (pcConfig && pcConfig.iceServers) {
        const newIceServers = [];
        for (let i = 0; i < pcConfig.iceServers.length; i++) {
          let server = pcConfig.iceServers[i];
          if (!server.hasOwnProperty('urls') &&
              server.hasOwnProperty('url')) {
            deprecated('RTCIceServer.url', 'RTCIceServer.urls');
            server = JSON.parse(JSON.stringify(server));
            server.urls = server.url;
            delete server.url;
            newIceServers.push(server);
          } else {
            newIceServers.push(pcConfig.iceServers[i]);
          }
        }
        pcConfig.iceServers = newIceServers;
      }
      return new OrigPeerConnection(pcConfig, pcConstraints);
    };
  window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
  // wrap static methods. Currently just generateCertificate.
  if ('generateCertificate' in OrigPeerConnection) {
    Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
      get() {
        return OrigPeerConnection.generateCertificate;
      }
    });
  }
}

function shimTrackEventTransceiver(window) {
  // Add event.transceiver member over deprecated event.receiver
  if (typeof window === 'object' && window.RTCTrackEvent &&
      'receiver' in window.RTCTrackEvent.prototype &&
      !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get() {
        return {receiver: this.receiver};
      }
    });
  }
}

function shimCreateOfferLegacy(window) {
  const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
  window.RTCPeerConnection.prototype.createOffer =
    function createOffer(offerOptions) {
      if (offerOptions) {
        if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveAudio =
            !!offerOptions.offerToReceiveAudio;
        }
        const audioTransceiver = this.getTransceivers().find(transceiver =>
          transceiver.receiver.track.kind === 'audio');
        if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
          if (audioTransceiver.direction === 'sendrecv') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('sendonly');
            } else {
              audioTransceiver.direction = 'sendonly';
            }
          } else if (audioTransceiver.direction === 'recvonly') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('inactive');
            } else {
              audioTransceiver.direction = 'inactive';
            }
          }
        } else if (offerOptions.offerToReceiveAudio === true &&
            !audioTransceiver) {
          this.addTransceiver('audio');
        }

        if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveVideo =
            !!offerOptions.offerToReceiveVideo;
        }
        const videoTransceiver = this.getTransceivers().find(transceiver =>
          transceiver.receiver.track.kind === 'video');
        if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
          if (videoTransceiver.direction === 'sendrecv') {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection('sendonly');
            } else {
              videoTransceiver.direction = 'sendonly';
            }
          } else if (videoTransceiver.direction === 'recvonly') {
            if (videoTransceiver.setDirection) {
              videoTransceiver.setDirection('inactive');
            } else {
              videoTransceiver.direction = 'inactive';
            }
          }
        } else if (offerOptions.offerToReceiveVideo === true &&
            !videoTransceiver) {
          this.addTransceiver('video');
        }
      }
      return origCreateOffer.apply(this, arguments);
    };
}

function shimAudioContext(window) {
  if (typeof window !== 'object' || window.AudioContext) {
    return;
  }
  window.AudioContext = window.webkitAudioContext;
}

var safariShim = /*#__PURE__*/Object.freeze({
    __proto__: null,
    shimLocalStreamsAPI: shimLocalStreamsAPI,
    shimRemoteStreamsAPI: shimRemoteStreamsAPI,
    shimCallbacksAPI: shimCallbacksAPI,
    shimGetUserMedia: shimGetUserMedia,
    shimConstraints: shimConstraints,
    shimRTCIceServerUrls: shimRTCIceServerUrls,
    shimTrackEventTransceiver: shimTrackEventTransceiver,
    shimCreateOfferLegacy: shimCreateOfferLegacy,
    shimAudioContext: shimAudioContext
});

var sdp$1 = {exports: {}};

/* eslint-env node */

(function (module) {

// SDP helpers.
const SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(line => line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  const parts = blob.split('\nm=');
  return parts.map((part, index) => (index > 0 ?
    'm=' + part : part).trim() + '\r\n');
};

// Returns the session description.
SDPUtils.getDescription = function(blob) {
  const sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};

// Returns the individual media sections.
SDPUtils.getMediaSections = function(blob) {
  const sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(line => line.indexOf(prefix) === 0);
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
SDPUtils.parseCandidate = function(line) {
  let parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  const candidate = {
    foundation: parts[0],
    component: {1: 'rtp', 2: 'rtcp'}[parts[1]] || parts[1],
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    address: parts[4], // address is an alias for ip.
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7],
  };

  for (let i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compatibility.
        candidate.usernameFragment = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag. Don't overwrite.
        if (candidate[parts[i]] === undefined) {
          candidate[parts[i]] = parts[i + 1];
        }
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
SDPUtils.writeCandidate = function(candidate) {
  const sdp = [];
  sdp.push(candidate.foundation);

  const component = candidate.component;
  if (component === 'rtp') {
    sdp.push(1);
  } else if (component === 'rtcp') {
    sdp.push(2);
  } else {
    sdp.push(component);
  }
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.address || candidate.ip);
  sdp.push(candidate.port);

  const type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
};

// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  let parts = line.substr(9).split(' ');
  const parsed = {
    payloadType: parseInt(parts.shift(), 10), // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  // legacy alias, got renamed back to channels in ORTC.
  parsed.numChannels = parsed.channels;
  return parsed;
};

// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  let pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  const channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (channels !== 1 ? '/' + channels : '') + '\r\n';
};

// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  const parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1],
  };
};

// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
        ? '/' + headerExtension.direction
        : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  const parsed = {};
  let kv;
  const parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (let j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  let line = '';
  let pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    const params = [];
    Object.keys(codec.parameters).forEach(param => {
      if (codec.parameters[param] !== undefined) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  const parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' '),
  };
};

// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  let lines = '';
  let pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(fb => {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  const sp = line.indexOf(' ');
  const parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10),
  };
  const colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
SDPUtils.parseSsrcGroup = function(line) {
  const parts = line.substr(13).split(' ');
  return {
    semantics: parts.shift(),
    ssrcs: parts.map(ssrc => parseInt(ssrc, 10)),
  };
};

// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  const mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};

// Parses a fingerprint line for DTLS-SRTP.
SDPUtils.parseFingerprint = function(line) {
  const parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1].toUpperCase(), // the definition is upper-case in RFC 4572.
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  const lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint),
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  let sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(fp => {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};

// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
SDPUtils.parseCryptoLine = function(line) {
  const parts = line.substr(9).split(' ');
  return {
    tag: parseInt(parts[0], 10),
    cryptoSuite: parts[1],
    keyParams: parts[2],
    sessionParams: parts.slice(3),
  };
};

SDPUtils.writeCryptoLine = function(parameters) {
  return 'a=crypto:' + parameters.tag + ' ' +
    parameters.cryptoSuite + ' ' +
    (typeof parameters.keyParams === 'object'
      ? SDPUtils.writeCryptoKeyParams(parameters.keyParams)
      : parameters.keyParams) +
    (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') +
    '\r\n';
};

// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
SDPUtils.parseCryptoKeyParams = function(keyParams) {
  if (keyParams.indexOf('inline:') !== 0) {
    return null;
  }
  const parts = keyParams.substr(7).split('|');
  return {
    keyMethod: 'inline',
    keySalt: parts[0],
    lifeTime: parts[1],
    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined,
  };
};

SDPUtils.writeCryptoKeyParams = function(keyParams) {
  return keyParams.keyMethod + ':'
    + keyParams.keySalt +
    (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') +
    (keyParams.mkiValue && keyParams.mkiLength
      ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength
      : '');
};

// Extracts all SDES parameters.
SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
  const lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=crypto:');
  return lines.map(SDPUtils.parseCryptoLine);
};

// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  const ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-ufrag:')[0];
  const pwd = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-pwd:')[0];
  if (!(ufrag && pwd)) {
    return null;
  }
  return {
    usernameFragment: ufrag.substr(12),
    password: pwd.substr(10),
  };
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
  if (params.iceLite) {
    sdp += 'a=ice-lite\r\n';
  }
  return sdp;
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  const description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: [],
  };
  const lines = SDPUtils.splitLines(mediaSection);
  const mline = lines[0].split(' ');
  for (let i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    const pt = mline[i];
    const rtpmapline = SDPUtils.matchPrefix(
      mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      const codec = SDPUtils.parseRtpMap(rtpmapline);
      const fmtps = SDPUtils.matchPrefix(
        mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
        mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(line => {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  let sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(codec => {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(codec => {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  let maxptime = 0;
  caps.codecs.forEach(codec => {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }

  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(extension => {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  const encodingParameters = [];
  const description = SDPUtils.parseRtpParameters(mediaSection);
  const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  const ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(line => SDPUtils.parseSsrcMedia(line))
    .filter(parts => parts.attribute === 'cname');
  const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  let secondarySsrc;

  const flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
    .map(line => {
      const parts = line.substr(17).split(' ');
      return parts.map(part => parseInt(part, 10));
    });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(codec => {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      let encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10),
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = {ssrc: secondarySsrc};
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: primarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red',
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc,
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  let bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(params => {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  const rtcpParameters = {};

  // Gets the first SSRC. Note that with RTX there might be multiple
  // SSRCs.
  const remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(line => SDPUtils.parseSsrcMedia(line))
    .filter(obj => obj.attribute === 'cname')[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  const rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  const mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

SDPUtils.writeRtcpParameters = function(rtcpParameters) {
  let sdp = '';
  if (rtcpParameters.reducedSize) {
    sdp += 'a=rtcp-rsize\r\n';
  }
  if (rtcpParameters.mux) {
    sdp += 'a=rtcp-mux\r\n';
  }
  if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) {
    sdp += 'a=ssrc:' + rtcpParameters.ssrc +
      ' cname:' + rtcpParameters.cname + '\r\n';
  }
  return sdp;
};


// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  let parts;
  const spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  const planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(line => SDPUtils.parseSsrcMedia(line))
    .filter(msidParts => msidParts.attribute === 'msid');
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
SDPUtils.parseSctpDescription = function(mediaSection) {
  const mline = SDPUtils.parseMLine(mediaSection);
  const maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
  let maxMessageSize;
  if (maxSizeLine.length > 0) {
    maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
  }
  if (isNaN(maxMessageSize)) {
    maxMessageSize = 65536;
  }
  const sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
  if (sctpPort.length > 0) {
    return {
      port: parseInt(sctpPort[0].substr(12), 10),
      protocol: mline.fmt,
      maxMessageSize,
    };
  }
  const sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
  if (sctpMapLines.length > 0) {
    const parts = sctpMapLines[0]
      .substr(10)
      .split(' ');
    return {
      port: parseInt(parts[0], 10),
      protocol: parts[1],
      maxMessageSize,
    };
  }
};

// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
SDPUtils.writeSctpDescription = function(media, sctp) {
  let output = [];
  if (media.protocol !== 'DTLS/SCTP') {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctp-port:' + sctp.port + '\r\n',
    ];
  } else {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n',
    ];
  }
  if (sctp.maxMessageSize !== undefined) {
    output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
  }
  return output.join('');
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};

// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
  let sessionId;
  const version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  const user = sessUser || 'thisisadapterortc';
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=' + user + ' ' + sessionId + ' ' + version +
        ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  const lines = SDPUtils.splitLines(mediaSection);
  for (let i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  const lines = SDPUtils.splitLines(mediaSection);
  const mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function(mediaSection) {
  const lines = SDPUtils.splitLines(mediaSection);
  const parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' '),
  };
};

SDPUtils.parseOLine = function(mediaSection) {
  const line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  const parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5],
  };
};

// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function(blob) {
  if (typeof blob !== 'string' || blob.length === 0) {
    return false;
  }
  const lines = SDPUtils.splitLines(blob);
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
      return false;
    }
    // TODO: check the modifier a bit more.
  }
  return true;
};

// Expose public methods.
{
  module.exports = SDPUtils;
}
}(sdp$1));

var SDPUtils = sdp$1.exports;

var sdp = /*#__PURE__*/Object.freeze(/*#__PURE__*/_mergeNamespaces({
    __proto__: null,
    'default': SDPUtils
}, [sdp$1.exports]));

/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimRTCIceCandidate(window) {
  // foundation is arbitrarily chosen as an indicator for full support for
  // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
  if (!window.RTCIceCandidate || (window.RTCIceCandidate && 'foundation' in
      window.RTCIceCandidate.prototype)) {
    return;
  }

  const NativeRTCIceCandidate = window.RTCIceCandidate;
  window.RTCIceCandidate = function RTCIceCandidate(args) {
    // Remove the a= which shouldn't be part of the candidate string.
    if (typeof args === 'object' && args.candidate &&
        args.candidate.indexOf('a=') === 0) {
      args = JSON.parse(JSON.stringify(args));
      args.candidate = args.candidate.substr(2);
    }

    if (args.candidate && args.candidate.length) {
      // Augment the native candidate with the parsed fields.
      const nativeCandidate = new NativeRTCIceCandidate(args);
      const parsedCandidate = SDPUtils.parseCandidate(args.candidate);
      const augmentedCandidate = Object.assign(nativeCandidate,
          parsedCandidate);

      // Add a serializer that does not serialize the extra attributes.
      augmentedCandidate.toJSON = function toJSON() {
        return {
          candidate: augmentedCandidate.candidate,
          sdpMid: augmentedCandidate.sdpMid,
          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
          usernameFragment: augmentedCandidate.usernameFragment,
        };
      };
      return augmentedCandidate;
    }
    return new NativeRTCIceCandidate(args);
  };
  window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;

  // Hook up the augmented candidate in onicecandidate and
  // addEventListener('icecandidate', ...)
  wrapPeerConnectionEvent(window, 'icecandidate', e => {
    if (e.candidate) {
      Object.defineProperty(e, 'candidate', {
        value: new window.RTCIceCandidate(e.candidate),
        writable: 'false'
      });
    }
    return e;
  });
}

function shimMaxMessageSize(window, browserDetails) {
  if (!window.RTCPeerConnection) {
    return;
  }

  if (!('sctp' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
      get() {
        return typeof this._sctp === 'undefined' ? null : this._sctp;
      }
    });
  }

  const sctpInDescription = function(description) {
    if (!description || !description.sdp) {
      return false;
    }
    const sections = SDPUtils.splitSections(description.sdp);
    sections.shift();
    return sections.some(mediaSection => {
      const mLine = SDPUtils.parseMLine(mediaSection);
      return mLine && mLine.kind === 'application'
          && mLine.protocol.indexOf('SCTP') !== -1;
    });
  };

  const getRemoteFirefoxVersion = function(description) {
    // TODO: Is there a better solution for detecting Firefox?
    const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (match === null || match.length < 2) {
      return -1;
    }
    const version = parseInt(match[1], 10);
    // Test for NaN (yes, this is ugly)
    return version !== version ? -1 : version;
  };

  const getCanSendMaxMessageSize = function(remoteIsFirefox) {
    // Every implementation we know can send at least 64 KiB.
    // Note: Although Chrome is technically able to send up to 256 KiB, the
    //       data does not reach the other peer reliably.
    //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
    let canSendMaxMessageSize = 65536;
    if (browserDetails.browser === 'firefox') {
      if (browserDetails.version < 57) {
        if (remoteIsFirefox === -1) {
          // FF < 57 will send in 16 KiB chunks using the deprecated PPID
          // fragmentation.
          canSendMaxMessageSize = 16384;
        } else {
          // However, other FF (and RAWRTC) can reassemble PPID-fragmented
          // messages. Thus, supporting ~2 GiB when sending.
          canSendMaxMessageSize = 2147483637;
        }
      } else if (browserDetails.version < 60) {
        // Currently, all FF >= 57 will reset the remote maximum message size
        // to the default value when a data channel is created at a later
        // stage. :(
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
        canSendMaxMessageSize =
          browserDetails.version === 57 ? 65535 : 65536;
      } else {
        // FF >= 60 supports sending ~2 GiB
        canSendMaxMessageSize = 2147483637;
      }
    }
    return canSendMaxMessageSize;
  };

  const getMaxMessageSize = function(description, remoteIsFirefox) {
    // Note: 65536 bytes is the default value from the SDP spec. Also,
    //       every implementation we know supports receiving 65536 bytes.
    let maxMessageSize = 65536;

    // FF 57 has a slightly incorrect default remote max message size, so
    // we need to adjust it here to avoid a failure when sending.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
    if (browserDetails.browser === 'firefox'
         && browserDetails.version === 57) {
      maxMessageSize = 65535;
    }

    const match = SDPUtils.matchPrefix(description.sdp,
      'a=max-message-size:');
    if (match.length > 0) {
      maxMessageSize = parseInt(match[0].substr(19), 10);
    } else if (browserDetails.browser === 'firefox' &&
                remoteIsFirefox !== -1) {
      // If the maximum message size is not present in the remote SDP and
      // both local and remote are Firefox, the remote peer can receive
      // ~2 GiB.
      maxMessageSize = 2147483637;
    }
    return maxMessageSize;
  };

  const origSetRemoteDescription =
      window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription =
    function setRemoteDescription() {
      this._sctp = null;
      // Chrome decided to not expose .sctp in plan-b mode.
      // As usual, adapter.js has to do an 'ugly worakaround'
      // to cover up the mess.
      if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
        const {sdpSemantics} = this.getConfiguration();
        if (sdpSemantics === 'plan-b') {
          Object.defineProperty(this, 'sctp', {
            get() {
              return typeof this._sctp === 'undefined' ? null : this._sctp;
            },
            enumerable: true,
            configurable: true,
          });
        }
      }

      if (sctpInDescription(arguments[0])) {
        // Check if the remote is FF.
        const isFirefox = getRemoteFirefoxVersion(arguments[0]);

        // Get the maximum message size the local peer is capable of sending
        const canSendMMS = getCanSendMaxMessageSize(isFirefox);

        // Get the maximum message size of the remote peer.
        const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);

        // Determine final maximum message size
        let maxMessageSize;
        if (canSendMMS === 0 && remoteMMS === 0) {
          maxMessageSize = Number.POSITIVE_INFINITY;
        } else if (canSendMMS === 0 || remoteMMS === 0) {
          maxMessageSize = Math.max(canSendMMS, remoteMMS);
        } else {
          maxMessageSize = Math.min(canSendMMS, remoteMMS);
        }

        // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
        // attribute.
        const sctp = {};
        Object.defineProperty(sctp, 'maxMessageSize', {
          get() {
            return maxMessageSize;
          }
        });
        this._sctp = sctp;
      }

      return origSetRemoteDescription.apply(this, arguments);
    };
}

function shimSendThrowTypeError(window) {
  if (!(window.RTCPeerConnection &&
      'createDataChannel' in window.RTCPeerConnection.prototype)) {
    return;
  }

  // Note: Although Firefox >= 57 has a native implementation, the maximum
  //       message size can be reset for all data channels at a later stage.
  //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831

  function wrapDcSend(dc, pc) {
    const origDataChannelSend = dc.send;
    dc.send = function send() {
      const data = arguments[0];
      const length = data.length || data.size || data.byteLength;
      if (dc.readyState === 'open' &&
          pc.sctp && length > pc.sctp.maxMessageSize) {
        throw new TypeError('Message too large (can send a maximum of ' +
          pc.sctp.maxMessageSize + ' bytes)');
      }
      return origDataChannelSend.apply(dc, arguments);
    };
  }
  const origCreateDataChannel =
    window.RTCPeerConnection.prototype.createDataChannel;
  window.RTCPeerConnection.prototype.createDataChannel =
    function createDataChannel() {
      const dataChannel = origCreateDataChannel.apply(this, arguments);
      wrapDcSend(dataChannel, this);
      return dataChannel;
    };
  wrapPeerConnectionEvent(window, 'datachannel', e => {
    wrapDcSend(e.channel, e.target);
    return e;
  });
}


/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */
function shimConnectionState(window) {
  if (!window.RTCPeerConnection ||
      'connectionState' in window.RTCPeerConnection.prototype) {
    return;
  }
  const proto = window.RTCPeerConnection.prototype;
  Object.defineProperty(proto, 'connectionState', {
    get() {
      return {
        completed: 'connected',
        checking: 'connecting'
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(proto, 'onconnectionstatechange', {
    get() {
      return this._onconnectionstatechange || null;
    },
    set(cb) {
      if (this._onconnectionstatechange) {
        this.removeEventListener('connectionstatechange',
            this._onconnectionstatechange);
        delete this._onconnectionstatechange;
      }
      if (cb) {
        this.addEventListener('connectionstatechange',
            this._onconnectionstatechange = cb);
      }
    },
    enumerable: true,
    configurable: true
  });

  ['setLocalDescription', 'setRemoteDescription'].forEach((method) => {
    const origMethod = proto[method];
    proto[method] = function() {
      if (!this._connectionstatechangepoly) {
        this._connectionstatechangepoly = e => {
          const pc = e.target;
          if (pc._lastConnectionState !== pc.connectionState) {
            pc._lastConnectionState = pc.connectionState;
            const newEvent = new Event('connectionstatechange', e);
            pc.dispatchEvent(newEvent);
          }
          return e;
        };
        this.addEventListener('iceconnectionstatechange',
          this._connectionstatechangepoly);
      }
      return origMethod.apply(this, arguments);
    };
  });
}

function removeExtmapAllowMixed(window, browserDetails) {
  /* remove a=extmap-allow-mixed for webrtc.org < M71 */
  if (!window.RTCPeerConnection) {
    return;
  }
  if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
    return;
  }
  if (browserDetails.browser === 'safari' && browserDetails.version >= 605) {
    return;
  }
  const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
  window.RTCPeerConnection.prototype.setRemoteDescription =
  function setRemoteDescription(desc) {
    if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
      const sdp = desc.sdp.split('\n').filter((line) => {
        return line.trim() !== 'a=extmap-allow-mixed';
      }).join('\n');
      // Safari enforces read-only-ness of RTCSessionDescription fields.
      if (window.RTCSessionDescription &&
          desc instanceof window.RTCSessionDescription) {
        arguments[0] = new window.RTCSessionDescription({
          type: desc.type,
          sdp,
        });
      } else {
        desc.sdp = sdp;
      }
    }
    return nativeSRD.apply(this, arguments);
  };
}

function shimAddIceCandidateNullOrEmpty(window, browserDetails) {
  // Support for addIceCandidate(null or undefined)
  // as well as addIceCandidate({candidate: "", ...})
  // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
  // Note: must be called before other polyfills which change the signature.
  if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
    return;
  }
  const nativeAddIceCandidate =
      window.RTCPeerConnection.prototype.addIceCandidate;
  if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) {
    return;
  }
  window.RTCPeerConnection.prototype.addIceCandidate =
    function addIceCandidate() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      // Firefox 68+ emits and processes {candidate: "", ...}, ignore
      // in older versions.
      // Native support for ignoring exists for Chrome M77+.
      // Safari ignores as well, exact version unknown but works in the same
      // version that also ignores addIceCandidate(null).
      if (((browserDetails.browser === 'chrome' && browserDetails.version < 78)
           || (browserDetails.browser === 'firefox'
               && browserDetails.version < 68)
           || (browserDetails.browser === 'safari'))
          && arguments[0] && arguments[0].candidate === '') {
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
}

// Note: Make sure to call this ahead of APIs that modify
// setLocalDescription.length
function shimParameterlessSetLocalDescription(window, browserDetails) {
  if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
    return;
  }
  const nativeSetLocalDescription =
      window.RTCPeerConnection.prototype.setLocalDescription;
  if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) {
    return;
  }
  window.RTCPeerConnection.prototype.setLocalDescription =
    function setLocalDescription() {
      let desc = arguments[0] || {};
      if (typeof desc !== 'object' || (desc.type && desc.sdp)) {
        return nativeSetLocalDescription.apply(this, arguments);
      }
      // The remaining steps should technically happen when SLD comes off the
      // RTCPeerConnection's operations chain (not ahead of going on it), but
      // this is too difficult to shim. Instead, this shim only covers the
      // common case where the operations chain is empty. This is imperfect, but
      // should cover many cases. Rationale: Even if we can't reduce the glare
      // window to zero on imperfect implementations, there's value in tapping
      // into the perfect negotiation pattern that several browsers support.
      desc = {type: desc.type, sdp: desc.sdp};
      if (!desc.type) {
        switch (this.signalingState) {
          case 'stable':
          case 'have-local-offer':
          case 'have-remote-pranswer':
            desc.type = 'offer';
            break;
          default:
            desc.type = 'answer';
            break;
        }
      }
      if (desc.sdp || (desc.type !== 'offer' && desc.type !== 'answer')) {
        return nativeSetLocalDescription.apply(this, [desc]);
      }
      const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
      return func.apply(this)
        .then(d => nativeSetLocalDescription.apply(this, [d]));
    };
}

var commonShim = /*#__PURE__*/Object.freeze({
    __proto__: null,
    shimRTCIceCandidate: shimRTCIceCandidate,
    shimMaxMessageSize: shimMaxMessageSize,
    shimSendThrowTypeError: shimSendThrowTypeError,
    shimConnectionState: shimConnectionState,
    removeExtmapAllowMixed: removeExtmapAllowMixed,
    shimAddIceCandidateNullOrEmpty: shimAddIceCandidateNullOrEmpty,
    shimParameterlessSetLocalDescription: shimParameterlessSetLocalDescription
});

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

// Shimming starts here.
function adapterFactory({window} = {}, options = {
  shimChrome: true,
  shimFirefox: true,
  shimSafari: true,
}) {
  // Utils.
  const logging = log;
  const browserDetails = detectBrowser(window);

  const adapter = {
    browserDetails,
    commonShim,
    extractVersion: extractVersion$1,
    disableLog: disableLog,
    disableWarnings: disableWarnings,
    // Expose sdp as a convenience. For production apps include directly.
    sdp,
  };

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !shimPeerConnection$1 ||
          !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      if (browserDetails.version === null) {
        logging('Chrome shim can not determine version, not shimming.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chromeShim;

      // Must be called before shimPeerConnection.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window);

      shimGetUserMedia$2(window, browserDetails);
      shimMediaStream(window);
      shimPeerConnection$1(window, browserDetails);
      shimOnTrack$1(window);
      shimAddTrackRemoveTrack(window, browserDetails);
      shimGetSendersWithDtmf(window);
      shimGetStats(window);
      shimSenderReceiverGetStats(window);
      fixNegotiationNeeded(window, browserDetails);

      shimRTCIceCandidate(window);
      shimConnectionState(window);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window);
      removeExtmapAllowMixed(window, browserDetails);
      break;
    case 'firefox':
      if (!firefoxShim || !shimPeerConnection ||
          !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefoxShim;

      // Must be called before shimPeerConnection.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window);

      shimGetUserMedia$1(window, browserDetails);
      shimPeerConnection(window, browserDetails);
      shimOnTrack(window);
      shimRemoveStream(window);
      shimSenderGetStats(window);
      shimReceiverGetStats(window);
      shimRTCDataChannel(window);
      shimAddTransceiver(window);
      shimGetParameters(window);
      shimCreateOffer(window);
      shimCreateAnswer(window);

      shimRTCIceCandidate(window);
      shimConnectionState(window);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window);
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safariShim;

      // Must be called before shimCallbackAPI.
      shimAddIceCandidateNullOrEmpty(window, browserDetails);
      shimParameterlessSetLocalDescription(window);

      shimRTCIceServerUrls(window);
      shimCreateOfferLegacy(window);
      shimCallbacksAPI(window);
      shimLocalStreamsAPI(window);
      shimRemoteStreamsAPI(window);
      shimTrackEventTransceiver(window);
      shimGetUserMedia(window);
      shimAudioContext(window);

      shimRTCIceCandidate(window);
      shimMaxMessageSize(window, browserDetails);
      shimSendThrowTypeError(window);
      removeExtmapAllowMixed(window, browserDetails);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
}

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

const adapter =
  adapterFactory({window: typeof window === 'undefined' ? undefined : window});

let nanoid = (size = 21) => {
  let id = '';
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte = bytes[size] & 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id += '_';
    } else {
      id += '-';
    }
  }
  return id
};

var es5 = {exports: {}};

(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n});},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return "NT";case"XP":return "XP";case"NT 5.0":return "2000";case"NT 5.1":return "XP";case"NT 5.2":return "2003";case"NT 6.0":return "Vista";case"NT 6.1":return "7";case"NT 6.2":return "8";case"NT 6.3":return "8.1";case"NT 10.0":return "10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return "Leopard";case 6:return "Snow Leopard";case 7:return "Lion";case 8:return "Mountain Lion";case 9:return "Mavericks";case 10:return "Yosemite";case 11:return "El Capitan";case 12:return "Sierra";case 13:return "High Sierra";case 14:return "Mojave";case 15:return "Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1;}else if(u[0][a]<u[1][a])return -1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t];}));};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default;},18:function(e,t,r){t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"};},90:function(e,t,r){t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default;},91:function(e,t,r){t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse();}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1);})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return ">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default;},92:function(e,t,r){t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return {name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default;},93:function(e,t,r){t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return {name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return {name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return {name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return {name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return {name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return {name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return {name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return {name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return {name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return {name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default;},94:function(e,t,r){t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return {type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return {type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return {type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return {type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return {type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return {type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return {type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return {type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return {type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return {type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return "blackberry"===e.getBrowserName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return "bada"===e.getBrowserName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return "windows phone"===e.getBrowserName()},describe:function(){return {type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return "android"===e.getOSName(!0)&&t>=3},describe:function(){return {type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return "android"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return "macos"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return "windows"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return "linux"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return "playstation 4"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.tv}}},{test:function(e){return "roku"===e.getOSName(!0)},describe:function(){return {type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default;},95:function(e,t,r){t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return "microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return {name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return {name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return {name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default;}})}));
}(es5));

var Bowser = /*@__PURE__*/getDefaultExportFromCjs(es5.exports);

// 快直播信令接口请求域名
// 全球加速请求域名
var REQUEST_DOMAIN_NAME_OVERSEAS = 'overseas-webrtc.liveplay.myqcloud.com';
// 连接重试默认次数
var CONNECT_RETRY_COUNT = 3;
// 连接最大重试次数
var CONNECT_MAX_RETRY_COUNT = 10;
// 连接重试时延
var CONNECT_RETRY_DELAY = 1;
// 连接最大重试时延
var CONNECT_MAX_RETRY_DELAY = 10;
// 流为空的最大统计次数
var MAX_STREAM_EMPTY_COUNT = 5;
// 视频流解码失败的最大统计次数
var MAX_STREAM_DECODE_FAIL_COUNT = 3;
// 最小解码帧率，小于这个说明卡顿
var MIN_DECODE_FRAMERATE = 5;
// video 默认样式
var VIDEO_DEFAULT_STYLE = 'max-width:100%;max-height:100%;object-fit:contain;display:block;margin:0 auto;';
// video 全屏样式
var VIDEO_FULLSCREEN_STYLE = 'position:fixed;overflow:hidden;z-index:9999;left:0;top:0;bottom:0;right:0;width:100% !important;height:100% !important;padding-top:0 !important;background-color:#000;';

var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionStatus[ConnectionStatus["CONNECTING"] = 1] = "CONNECTING";
    ConnectionStatus[ConnectionStatus["ESTABLISHED"] = 2] = "ESTABLISHED";
})(ConnectionStatus || (ConnectionStatus = {}));
var RtcConnectCode;
(function (RtcConnectCode) {
    RtcConnectCode[RtcConnectCode["FAILURE"] = -1] = "FAILURE";
    RtcConnectCode[RtcConnectCode["SUCCESS"] = 0] = "SUCCESS";
})(RtcConnectCode || (RtcConnectCode = {}));
var RtcDisconnectCode;
(function (RtcDisconnectCode) {
    RtcDisconnectCode[RtcDisconnectCode["NEED_RECONNECT"] = -1] = "NEED_RECONNECT";
    RtcDisconnectCode[RtcDisconnectCode["MANUAL_CLOSE"] = 0] = "MANUAL_CLOSE";
})(RtcDisconnectCode || (RtcDisconnectCode = {}));
var ConnectionDirection;
(function (ConnectionDirection) {
    ConnectionDirection[ConnectionDirection["SEND"] = 0] = "SEND";
    ConnectionDirection[ConnectionDirection["RECEIVE"] = 1] = "RECEIVE";
})(ConnectionDirection || (ConnectionDirection = {}));
var PlayingStatus;
(function (PlayingStatus) {
    PlayingStatus[PlayingStatus["INIT"] = 0] = "INIT";
    PlayingStatus[PlayingStatus["PLAYING"] = 1] = "PLAYING";
    PlayingStatus[PlayingStatus["WAITING"] = 2] = "WAITING";
})(PlayingStatus || (PlayingStatus = {}));

var PlayEventCode;
(function (PlayEventCode) {
    PlayEventCode[PlayEventCode["PLAY_EVT_STREAM_BEGIN"] = 1001] = "PLAY_EVT_STREAM_BEGIN";
    PlayEventCode[PlayEventCode["PLAY_EVT_SERVER_CONNECTED"] = 1002] = "PLAY_EVT_SERVER_CONNECTED";
    PlayEventCode[PlayEventCode["PLAY_EVT_PLAY_BEGIN"] = 1003] = "PLAY_EVT_PLAY_BEGIN";
    PlayEventCode[PlayEventCode["PLAY_EVT_PLAY_STOP"] = 1004] = "PLAY_EVT_PLAY_STOP";
    PlayEventCode[PlayEventCode["PLAY_EVT_SERVER_RECONNECT"] = 1005] = "PLAY_EVT_SERVER_RECONNECT";
    PlayEventCode[PlayEventCode["PLAY_EVT_STREAM_EMPTY"] = 1006] = "PLAY_EVT_STREAM_EMPTY";
    PlayEventCode[PlayEventCode["PLAY_EVT_REQUEST_PULL_BEGIN"] = 1007] = "PLAY_EVT_REQUEST_PULL_BEGIN";
    PlayEventCode[PlayEventCode["PLAY_EVT_REQUEST_PULL_SUCCESS"] = 1008] = "PLAY_EVT_REQUEST_PULL_SUCCESS";
    PlayEventCode[PlayEventCode["PLAY_EVT_PLAY_WAITING_BEGIN"] = 1009] = "PLAY_EVT_PLAY_WAITING_BEGIN";
    PlayEventCode[PlayEventCode["PLAY_EVT_PLAY_WAITING_STOP"] = 1010] = "PLAY_EVT_PLAY_WAITING_STOP";
    PlayEventCode[PlayEventCode["PLAY_ERR_WEBRTC_FAIL"] = -2001] = "PLAY_ERR_WEBRTC_FAIL";
    PlayEventCode[PlayEventCode["PLAY_ERR_REQUEST_PULL_FAIL"] = -2002] = "PLAY_ERR_REQUEST_PULL_FAIL";
    PlayEventCode[PlayEventCode["PLAY_ERR_PLAY_FAIL"] = -2003] = "PLAY_ERR_PLAY_FAIL";
    PlayEventCode[PlayEventCode["PLAY_ERR_SERVER_DISCONNECT"] = -2004] = "PLAY_ERR_SERVER_DISCONNECT";
    PlayEventCode[PlayEventCode["PLAY_ERR_DECODE_FAIL"] = -2005] = "PLAY_ERR_DECODE_FAIL";
})(PlayEventCode || (PlayEventCode = {}));

var tbsReg = /tbs\/(\d+) /i;
var firefoxReg = /firefox\/(\d+)\./i;
var safariReg = /safari\/(\d+)\./i;
var chromeReg = /chrome\/(\d+)\./i;
var ucReg = /UCBrowser\/(\d+)\./i;
var iOSReg = /iPhone|iPad|iOS/i;
var iOSVersionReg = /OS (\d+)_(\d+)_?(\d+)?/;
/**
 * 检测是否是x5内核
 */
var isTbs = tbsReg.test(navigator.userAgent);
/**
 * 检测是否是firefox
 */
var isFirefox = firefoxReg.test(navigator.userAgent);
var IS_FIREFOX = isFirefox;
/**
 * 检测是否是uc浏览器
 */
var isUCBrowser = ucReg.test(navigator.userAgent);
/**
 * 检测是否是safari
 */
var isSafari = safariReg.test(navigator.userAgent) && !chromeReg.test(navigator.userAgent);
/**
 * 检测是否是iOS
 */
var isIOS = iOSReg.test(navigator.userAgent);
var IS_IOS = isIOS;
/**
 * 获取iOS版本
 */
var getIOSVersion = function () {
    var match = navigator.userAgent.match(iOSVersionReg);
    return (match && [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || '0', 10)]) || [];
};
/**
 * Extract browser version out of the provided user agent string.
 *
 * @param uastring userAgent string.
 * @param expr Regular expression used as match criteria.
 * @param pos position in the version string to be returned.
 * @return browser version.
 */
var extractVersion = function (uastring, expr, pos) {
    var match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
};
/**
 * 检测是否支持h264
 */
var checkH264Support = function () { return __awaiter(void 0, void 0, void 0, function () {
    var configuration, peerConnection, offerOptions, offer, isSupported;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                configuration = {
                    iceServers: [],
                    sdpSemantics: 'unified-plan', // QQ浏览器，不加这个参数，无法使用addTransceiver方法，会报错
                };
                peerConnection = new RTCPeerConnection(configuration);
                offerOptions = {};
                if (peerConnection.addTransceiver) {
                    peerConnection.addTransceiver('audio', { direction: 'recvonly' });
                    peerConnection.addTransceiver('video', { direction: 'recvonly' });
                }
                else {
                    offerOptions = { offerToReceiveVideo: true, offerToReceiveAudio: true };
                }
                return [4 /*yield*/, peerConnection.createOffer(offerOptions)];
            case 1:
                offer = _a.sent();
                isSupported = offer.sdp.toLowerCase().indexOf('h264') > -1;
                peerConnection.close();
                return [2 /*return*/, isSupported];
            case 2:
                _a.sent();
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * 检测浏览器是否支持webrtc
 */
var checkSupport = function () { return __awaiter(void 0, void 0, void 0, function () {
    var isWebRTCSupported, iOSVersion, isH264Supported, ret;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isWebRTCSupported = false;
                ['RTCPeerConnection', 'webkitRTCPeerConnection'].forEach(function (item) {
                    if (isWebRTCSupported) {
                        return;
                    }
                    if (item in window) {
                        isWebRTCSupported = true;
                    }
                });
                if (!isTbs) {
                    if (isUCBrowser && isIOS) {
                        // android的uc浏览器直接就不支持webrtc，ios的uc浏览器会劫持video标签，导致无法播放视频流
                        isWebRTCSupported = false;
                    }
                    else if (isSafari && isIOS) {
                        iOSVersion = getIOSVersion();
                        // iOS 11.1.2 以下版本不支持
                        if (iOSVersion.length === 0 ||
                            iOSVersion[0] < 11 ||
                            (iOSVersion[0] === 11 && iOSVersion[1] < 1) ||
                            (iOSVersion[0] === 11 && iOSVersion[1] === 1 && iOSVersion[2] < 2)) {
                            isWebRTCSupported = false;
                        }
                    }
                }
                return [4 /*yield*/, checkH264Support()];
            case 1:
                isH264Supported = _a.sent();
                ret = {
                    support: isWebRTCSupported,
                    isTbs: isTbs,
                    tbsVersion: isTbs ? extractVersion(navigator.userAgent, tbsReg, 1) : null,
                    isFirefox: isFirefox,
                    isSafari: isSafari,
                    isIOS: isIOS,
                    iOSVersion: isIOS ? getIOSVersion().join('.') : null,
                    h264Support: isH264Supported,
                };
                return [2 /*return*/, ret];
        }
    });
}); };

/**
 * 根据拉流地址获取流id
 * @param url 拉流地址
 */
var getStreamId = function (url) {
    // 拉流地址格式是 webrtc://domain/path/stream_id[?txSecret=xxx&txTime=xxx]
    var parseStreamIdV0 = /^(?:webrtc:\/\/)(?:[0-9.\-A-Za-z_]+)(?:\/)(?:[0-9.\-A-Za-z_]+)(?:\/)([^?#]*)(?:\?*)(?:[^?#]*)/;
    var resultV0 = parseStreamIdV0.exec(url);
    if (resultV0) {
        return resultV0[1];
    }
    // 拉流地址格式是 http[s]://domain/path/stream_id.sdp[?txSecret=xxx&txTime=xxx]
    var parseStreamIdV1 = /^(?:https?:\/\/)(?:[0-9.\-A-Za-z_]+)(?:\/)(?:[0-9.\-A-Za-z_]+)(?:\/)([^?#]*)(?:\.sdp)(?:\?*)(?:[^?#]*)/;
    var resultV1 = parseStreamIdV1.exec(url);
    if (resultV1) {
        return resultV1[1];
    }
    return null;
};

var baseUrl = "https://" + REQUEST_DOMAIN_NAME_OVERSEAS + "/webrtc/v1";
var fetchPost = function (url, data) {
    // eslint-disable-next-line implicit-arrow-linebreak
    return fetch(url, {
        body: JSON.stringify(data),
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors', // no-cors, cors, *same-origin
    }).then(function (response) { return response.json(); });
}; // parses response to JSON
var fetchPullStream = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var reqUrl, data, errcode, errmsg, remotesdp, svrsig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                reqUrl = baseUrl + "/pullstream";
                return [4 /*yield*/, fetchPost(reqUrl, params)];
            case 1:
                data = _a.sent();
                errcode = data.errcode, errmsg = data.errmsg, remotesdp = data.remotesdp, svrsig = data.svrsig;
                if (errcode !== 0) {
                    throw new Error("errCode:" + errcode + ", errMsg:" + errmsg);
                }
                return [2 /*return*/, { remoteSdp: remotesdp, svrSig: svrsig }];
        }
    });
}); };
var fetchStopStream = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var reqUrl, data, errcode, errmsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                reqUrl = baseUrl + "/stopstream";
                return [4 /*yield*/, fetchPost(reqUrl, params)];
            case 1:
                data = _a.sent();
                errcode = data.errcode, errmsg = data.errmsg;
                if (errcode !== 0) {
                    throw new Error("stop stream failed, errCode:" + errcode + ", errmsg:" + errmsg);
                }
                return [2 /*return*/, data];
        }
    });
}); };
var fetchStreamSdp = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var streamurl, sessionid, localsdp, data, code, message, remoteSdp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                streamurl = params.streamurl, sessionid = params.sessionid, localsdp = params.localsdp;
                return [4 /*yield*/, fetchPost(streamurl, {
                        version: 'v1.0',
                        sessionId: sessionid,
                        localSdp: localsdp,
                    })];
            case 1:
                data = _a.sent();
                code = data.code, message = data.message, remoteSdp = data.remoteSdp;
                if (code !== 200) {
                    throw new Error("errCode:" + code + ", errMsg:" + message);
                }
                return [2 /*return*/, { remoteSdp: remoteSdp, svrSig: null }];
        }
    });
}); };

var e_1, _a;
var FULL_SCREEN_API = {};
// browser API methods
var apiMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror',
    ],
    // WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
    ],
    // Old WebKit (Safari 5.1)
    [
        'webkitRequestFullScreen',
        'webkitCancelFullScreen',
        'webkitCurrentFullScreenElement',
        'webkitCancelFullScreen',
        'webkitfullscreenchange',
        'webkitfullscreenerror',
    ],
    // Mozilla
    [
        'mozRequestFullScreen',
        'mozCancelFullScreen',
        'mozFullScreenElement',
        'mozFullScreenEnabled',
        'mozfullscreenchange',
        'mozfullscreenerror',
    ],
    // Microsoft
    [
        'msRequestFullscreen',
        'msExitFullscreen',
        'msFullscreenElement',
        'msFullscreenEnabled',
        'MSFullscreenChange',
        'MSFullscreenError',
    ],
];
var specApi = apiMap[0];
var browserApi;
try {
    // determine the supported set of functions
    for (var apiMap_1 = __values(apiMap), apiMap_1_1 = apiMap_1.next(); !apiMap_1_1.done; apiMap_1_1 = apiMap_1.next()) {
        var apiMapItem = apiMap_1_1.value;
        // check for exitFullscreen function
        if (apiMapItem[1] in document) {
            browserApi = apiMapItem;
            break;
        }
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (apiMap_1_1 && !apiMap_1_1.done && (_a = apiMap_1.return)) _a.call(apiMap_1);
    }
    finally { if (e_1) throw e_1.error; }
}
// map the browser API names to the spec API names
if (browserApi) {
    for (var i = 0; i < browserApi.length; i++) {
        FULL_SCREEN_API[specApi[i]] = browserApi[i];
    }
}
// 检查是否支持 webkitEnterFullScreen
var supportFullScreen = function (videoEl) {
    if (typeof videoEl.webkitEnterFullScreen === 'function') {
        var userAgent = navigator.userAgent || '';
        // Seems to be broken in Chromium/Chrome && Safari in Leopard
        if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
            return true;
        }
    }
    return false;
};

var getWebRTCStats = function (curStats, lastStats) {
    if (lastStats === void 0) { lastStats = null; }
    if (!lastStats) {
        return;
    }
    var videoTrackId = null;
    var videoRtpId = null;
    var audioTrackId = null;
    var audioRtpId = null;
    curStats.forEach(function (report) {
        if (report.type === 'track') {
            if (report.kind === 'video' || report.frameWidth) {
                videoTrackId = report.id;
            }
            else if (report.kind === 'audio' || report.audioLevel) {
                audioTrackId = report.id;
            }
        }
        if (report.type === 'inbound-rtp') {
            if (report.kind === 'video' || report.mediaType === 'video') {
                videoRtpId = report.id;
            }
            else if (report.kind === 'audio' || report.mediaType === 'audio') {
                audioRtpId = report.id;
            }
        }
    });
    // video
    var curVideoTrack = curStats.get(videoTrackId);
    var curVideoRtp = curStats.get(videoRtpId);
    var lastVideoTrack = lastStats.get(videoTrackId);
    var lastVideoRtp = lastStats.get(videoRtpId);
    var time = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.timestamp) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.timestamp) !== undefined) {
        time = (curVideoRtp.timestamp - lastVideoRtp.timestamp) / 1000; // 两次统计数据之间的时间间隔，单位：秒
    }
    // 获取video codec
    var videoCodec = undefined;
    if (curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.codecId) {
        var codec = curStats.get(curVideoRtp.codecId);
        if (codec) {
            var mimeType = codec.mimeType, payloadType = codec.payloadType, sdpFmtpLine = codec.sdpFmtpLine;
            videoCodec = (mimeType === null || mimeType === void 0 ? void 0 : mimeType.replace('video/', '')) || '';
            if (payloadType && sdpFmtpLine) {
                videoCodec = videoCodec + " (" + payloadType + ", " + sdpFmtpLine + ")";
            }
        }
    }
    // 计算video fps
    var videoFps = undefined;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framesPerSecond) !== undefined) {
        // chrome浏览器
        videoFps = curVideoRtp.framesPerSecond;
    }
    else if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framerateMean) !== undefined) {
        // firefox浏览器
        videoFps = curVideoRtp.framerateMean;
    }
    else if ((curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.framesReceived) !== undefined && (lastVideoTrack === null || lastVideoTrack === void 0 ? void 0 : lastVideoTrack.framesReceived) !== undefined && time) {
        // safari下不存在framesPerSecond，就通过framesReceived来计算
        videoFps = (curVideoTrack.framesReceived - lastVideoTrack.framesReceived) / time;
    }
    // 计算video decode fps
    var videoDecodeFps = undefined;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framesDecoded) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.framesDecoded) !== undefined && time) {
        videoDecodeFps = (curVideoRtp.framesDecoded - lastVideoRtp.framesDecoded) / time;
    }
    // 计算video bitrate
    var videoBitrate = undefined;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.bytesReceived) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.bytesReceived) !== undefined && time) {
        videoBitrate = (8 * (curVideoRtp.bytesReceived - lastVideoRtp.bytesReceived)) / time; // 单位：bps
    }
    // 计算 video jitterBufferDelay
    var videoJitterBufferDelay = undefined;
    if ((curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.jitterBufferDelay) !== undefined &&
        (curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.jitterBufferEmittedCount) !== undefined &&
        (lastVideoTrack === null || lastVideoTrack === void 0 ? void 0 : lastVideoTrack.jitterBufferDelay) !== undefined &&
        (lastVideoTrack === null || lastVideoTrack === void 0 ? void 0 : lastVideoTrack.jitterBufferEmittedCount) !== undefined) {
        if (curVideoTrack.jitterBufferEmittedCount - lastVideoTrack.jitterBufferEmittedCount) {
            // 这种计算方式更准确，更接近chrome debug工具的结果
            videoJitterBufferDelay =
                ((curVideoTrack.jitterBufferDelay - lastVideoTrack.jitterBufferDelay) /
                    (curVideoTrack.jitterBufferEmittedCount - lastVideoTrack.jitterBufferEmittedCount)) *
                    1000;
        }
        else {
            videoJitterBufferDelay = (curVideoTrack.jitterBufferDelay / curVideoTrack.jitterBufferEmittedCount) * 1000;
        }
    }
    // 计算video average decode time
    var videoDecodeAvgTime = undefined;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.totalDecodeTime) !== undefined &&
        (curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.framesDecoded) !== undefined &&
        (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.totalDecodeTime) !== undefined &&
        (lastVideoTrack === null || lastVideoTrack === void 0 ? void 0 : lastVideoTrack.framesDecoded) !== undefined) {
        if (curVideoTrack.framesDecoded - lastVideoTrack.framesDecoded) {
            // 这种计算方式更准确，更接近chrome debug工具的结果
            videoDecodeAvgTime =
                ((curVideoRtp.totalDecodeTime - lastVideoRtp.totalDecodeTime) /
                    (curVideoTrack.framesDecoded - lastVideoTrack.framesDecoded)) *
                    1000;
        }
        else {
            videoDecodeAvgTime = (curVideoRtp.totalDecodeTime / curVideoTrack.framesDecoded) * 1000;
        }
    }
    // audio
    var curAudioTrack = curStats.get(audioTrackId);
    var curAudioRtp = curStats.get(audioRtpId);
    var lastAudioTrack = lastStats.get(audioTrackId);
    var lastAudioRtp = lastStats.get(audioRtpId);
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.timestamp) !== undefined && (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.timestamp) !== undefined) {
        time = (curAudioRtp.timestamp - lastAudioRtp.timestamp) / 1000; // 两次统计数据之间的时间间隔，单位：秒
    }
    // 获取audio codec
    var audioCodec = undefined;
    if (curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.codecId) {
        var codec = curStats.get(curAudioRtp.codecId);
        if (codec) {
            var mimeType = codec.mimeType, payloadType = codec.payloadType, sdpFmtpLine = codec.sdpFmtpLine;
            audioCodec = (mimeType === null || mimeType === void 0 ? void 0 : mimeType.replace('audio/', '')) || '';
            if (payloadType && sdpFmtpLine) {
                audioCodec = audioCodec + " (" + payloadType + ", " + sdpFmtpLine + ")";
            }
        }
    }
    // 获取 audioLevel
    var audioLevel = undefined;
    if ((curAudioTrack === null || curAudioTrack === void 0 ? void 0 : curAudioTrack.audioLevel) !== undefined) {
        audioLevel = curAudioTrack === null || curAudioTrack === void 0 ? void 0 : curAudioTrack.audioLevel;
    }
    else if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.audioLevel) !== undefined) {
        audioLevel = curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.audioLevel;
    }
    // 计算audio bitrate
    var audioBitrate = undefined;
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.bytesReceived) !== undefined && (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.bytesReceived) !== undefined && time) {
        audioBitrate = (8 * (curAudioRtp.bytesReceived - lastAudioRtp.bytesReceived)) / time; // 单位：bps
    }
    // 计算audio jitterBufferDelay
    var audioJitterBufferDelay = undefined;
    if ((curAudioTrack === null || curAudioTrack === void 0 ? void 0 : curAudioTrack.jitterBufferDelay) !== undefined &&
        (curAudioTrack === null || curAudioTrack === void 0 ? void 0 : curAudioTrack.jitterBufferEmittedCount) !== undefined &&
        (lastAudioTrack === null || lastAudioTrack === void 0 ? void 0 : lastAudioTrack.jitterBufferDelay) !== undefined &&
        (lastAudioTrack === null || lastAudioTrack === void 0 ? void 0 : lastAudioTrack.jitterBufferEmittedCount) !== undefined) {
        if (curAudioTrack.jitterBufferEmittedCount - lastAudioTrack.jitterBufferEmittedCount) {
            // 这种计算方式更准确，更接近chrome debug工具的结果
            audioJitterBufferDelay =
                ((curAudioTrack.jitterBufferDelay - lastAudioTrack.jitterBufferDelay) /
                    (curAudioTrack.jitterBufferEmittedCount - lastAudioTrack.jitterBufferEmittedCount)) *
                    1000;
        }
        else {
            audioJitterBufferDelay = (curAudioTrack.jitterBufferDelay / curAudioTrack.jitterBufferEmittedCount) * 1000;
        }
    }
    return {
        timestamp: (curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.timestamp) || (curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.timestamp),
        video: {
            codec: videoCodec,
            bitrate: videoBitrate && Number(videoBitrate.toFixed(2)),
            framesPerSecond: videoFps && Math.round(videoFps),
            framesDecodedPerSecond: videoDecodeFps && Math.round(videoDecodeFps),
            frameWidth: curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.frameWidth,
            frameHeight: curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.frameHeight,
            framesDecoded: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framesDecoded,
            framesDropped: curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.framesDropped,
            framesReceived: curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.framesReceived,
            packetsLost: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsLost,
            packetsReceived: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsReceived,
            nackCount: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.nackCount,
            firCount: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.firCount,
            pliCount: curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.pliCount,
            jitterBufferDelay: videoJitterBufferDelay && Number(videoJitterBufferDelay.toFixed(2)),
            frameDecodeAvgTime: videoDecodeAvgTime && Number(videoDecodeAvgTime.toFixed(2)), // 平均解码时间，firefox下不存在
        },
        audio: {
            codec: audioCodec,
            audioLevel: audioLevel,
            bitrate: audioBitrate && Number(audioBitrate.toFixed(2)),
            packetsLost: curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsLost,
            packetsReceived: curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsReceived,
            jitterBufferDelay: audioJitterBufferDelay && Number(audioJitterBufferDelay.toFixed(2)), // 抖动缓冲区平均延时，safari下不存在，firefox下不存在
        },
    };
};
var getServerStat = function (curStats) {
    var serverCandidateId = null;
    curStats.forEach(function (report) {
        // const { type, state, nominated, availableOutgoingBitrate, selected, remoteCandidateId } = report;
        // if (
        //   type === 'candidate-pair' && // 候选对，包括本地和远程的candidate
        //   state === 'succeeded' && // 候选者之间的连接状态
        //   nominated && // 是否被提名使用
        //   (availableOutgoingBitrate > 0 || selected || writable) // availableOutgoingBitrate 选中的候选对才有这个字段（chrome/safari） selected 是否被选中（firefox）writable 是否可以接收数据（刚建立连接时safari可能没有availableOutgoingBitrate）
        // ) {
        //   serverCandidateId = remoteCandidateId;
        // }
        var _a;
        if (report.type === 'candidate-pair' && report.selected) {
            // selected是firefox特定字段，表示正在使用的候选对
            serverCandidateId = report.remoteCandidateId;
        }
        else if (report.type === 'transport' && report.selectedCandidatePairId) {
            // 标准的方式是查找transport的selectedCandidatePairId字段
            serverCandidateId = (_a = curStats.get(report.selectedCandidatePairId)) === null || _a === void 0 ? void 0 : _a.remoteCandidateId;
        }
    });
    var serverCandidate = curStats.get(serverCandidateId) || {};
    var _a = serverCandidate.address, address = _a === void 0 ? '' : _a, _b = serverCandidate.port, port = _b === void 0 ? '' : _b;
    return {
        address: address,
        port: port,
    };
};
var getStopReportStat = function (curStats, lastStats) {
    var videoTrackId = null;
    var videoRtpId = null;
    var audioRtpId = null;
    curStats.forEach(function (report) {
        if (report.type === 'track' && (report.kind === 'video' || report.frameWidth)) {
            videoTrackId = report.id;
        }
        if (report.type === 'inbound-rtp') {
            if (report.kind === 'video' || report.mediaType === 'video') {
                videoRtpId = report.id;
            }
            else if (report.kind === 'audio' || report.mediaType === 'audio') {
                audioRtpId = report.id;
            }
        }
    });
    var curVideoTrack = curStats.get(videoTrackId);
    var curVideoRtp = curStats.get(videoRtpId);
    var curAudioRtp = curStats.get(audioRtpId);
    var lastVideoRtp = lastStats === null || lastStats === void 0 ? void 0 : lastStats.get(videoRtpId);
    var time = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.timestamp) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.timestamp) !== undefined) {
        time = (curVideoRtp.timestamp - lastVideoRtp.timestamp) / 1000; // 两次统计数据之间的时间间隔，单位：秒
    }
    var videoFractionLost = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsLost) !== undefined && (curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsReceived) !== undefined) {
        // packetsLost在Chrome和Safari上面并不是累加值，丢包率会不准
        videoFractionLost = (curVideoRtp.packetsLost / (curVideoRtp.packetsLost + curVideoRtp.packetsReceived)) * 1000; // 3%上报30，计算总的丢包率
    }
    var audioFractionLost = 0;
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsLost) !== undefined && (curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsReceived) !== undefined) {
        audioFractionLost = (curAudioRtp.packetsLost / (curAudioRtp.packetsLost + curAudioRtp.packetsReceived)) * 1000; // 3%上报30，计算总的丢包率
    }
    var framerateMean = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framesDecoded) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.framesDecoded) !== undefined && time) {
        framerateMean = Math.round((curVideoRtp.framesDecoded - lastVideoRtp.framesDecoded) / time);
    }
    return {
        width: (curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.frameWidth) || 0,
        height: (curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.frameHeight) || 0,
        videoFractionLost: Number(videoFractionLost.toFixed(2)),
        audioFractionLost: Number(audioFractionLost.toFixed(2)),
        framerateMean: framerateMean,
    };
};
var getIntervalReportStat = function (curStats, lastStats) {
    var videoTrackId = null;
    var videoRtpId = null;
    var audioRtpId = null;
    var candidatePairId = null;
    curStats.forEach(function (report) {
        if (report.type === 'track') {
            if (report.kind === 'video' || report.frameWidth) {
                videoTrackId = report.id;
            }
        }
        if (report.type === 'inbound-rtp') {
            if (report.kind === 'video' || report.mediaType === 'video') {
                videoRtpId = report.id;
            }
            else if (report.kind === 'audio' || report.mediaType === 'audio') {
                audioRtpId = report.id;
            }
        }
        if (report.type === 'candidate-pair' && report.selected) {
            // selected是firefox特定字段，表示正在使用的候选对
            candidatePairId = report.id;
        }
        else if (report.type === 'transport' && report.selectedCandidatePairId) {
            // 标准的方式是查找transport的selectedCandidatePairId字段
            candidatePairId = report.selectedCandidatePairId;
        }
    });
    // video
    var curVideoTrack = curStats.get(videoTrackId);
    var curVideoRtp = curStats.get(videoRtpId);
    var lastVideoTrack = lastStats === null || lastStats === void 0 ? void 0 : lastStats.get(videoTrackId);
    var lastVideoRtp = lastStats === null || lastStats === void 0 ? void 0 : lastStats.get(videoRtpId);
    var time = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.timestamp) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.timestamp) !== undefined) {
        time = (curVideoRtp.timestamp - lastVideoRtp.timestamp) / 1000; // 两次统计数据之间的时间间隔，单位：秒
    }
    var videoPacketsLost = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsLost) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.packetsLost) !== undefined) {
        videoPacketsLost = curVideoRtp.packetsLost - lastVideoRtp.packetsLost; // 区间视频丢包数
    }
    var videoReceiveFps = 0;
    if ((curVideoTrack === null || curVideoTrack === void 0 ? void 0 : curVideoTrack.framesReceived) !== undefined && (lastVideoTrack === null || lastVideoTrack === void 0 ? void 0 : lastVideoTrack.framesReceived) !== undefined && time) {
        // chrome/safari
        videoReceiveFps = (curVideoTrack.framesReceived - lastVideoTrack.framesReceived) / time; // 接收帧率
    }
    else if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framerateMean) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.framerateMean) !== undefined) {
        // firefox
        videoReceiveFps = (curVideoRtp.framerateMean + lastVideoRtp.framerateMean) / 2;
    }
    var videoDecodeFps = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.framesDecoded) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.framesDecoded) !== undefined && time) {
        videoDecodeFps = (curVideoRtp.framesDecoded - lastVideoRtp.framesDecoded) / time; // 解码帧率
    }
    var videoBitrate = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.bytesReceived) !== undefined && (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.bytesReceived) !== undefined && time) {
        videoBitrate = (8 * (curVideoRtp.bytesReceived - lastVideoRtp.bytesReceived)) / time / 1024; // 视频码率，单位：kbps
    }
    // 区间视频丢包率
    var videoFractionLost = 0;
    if ((curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsLost) !== undefined &&
        (curVideoRtp === null || curVideoRtp === void 0 ? void 0 : curVideoRtp.packetsReceived) !== undefined &&
        (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.packetsLost) !== undefined &&
        (lastVideoRtp === null || lastVideoRtp === void 0 ? void 0 : lastVideoRtp.packetsReceived) !== undefined) {
        var packetsLost = curVideoRtp.packetsLost - lastVideoRtp.packetsLost;
        var packetsReceived = curVideoRtp.packetsReceived - lastVideoRtp.packetsReceived;
        videoFractionLost = (packetsLost / (packetsLost + packetsReceived)) * 1000; // 3%上报30，计算区间总的丢包率
    }
    // audio
    var curAudioRtp = curStats.get(audioRtpId);
    var lastAudioRtp = lastStats === null || lastStats === void 0 ? void 0 : lastStats.get(audioRtpId);
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.timestamp) !== undefined && (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.timestamp) !== undefined) {
        time = (curAudioRtp.timestamp - lastAudioRtp.timestamp) / 1000; // 两次统计数据之间的时间间隔，单位：秒
    }
    var audioPacketsLost = 0;
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsLost) !== undefined && (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.packetsLost) !== undefined) {
        audioPacketsLost = curAudioRtp.packetsLost - lastAudioRtp.packetsLost; // 区间音频丢包数
    }
    var audioBitrate = 0;
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.bytesReceived) !== undefined && (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.bytesReceived) !== undefined && time) {
        audioBitrate = (8 * (curAudioRtp.bytesReceived - lastAudioRtp.bytesReceived)) / time / 1024; // 音频码率，单位：kbps
    }
    // 区间音频丢包率
    var audioFractionLost = 0;
    if ((curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsLost) !== undefined &&
        (curAudioRtp === null || curAudioRtp === void 0 ? void 0 : curAudioRtp.packetsReceived) !== undefined &&
        (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.packetsLost) !== undefined &&
        (lastAudioRtp === null || lastAudioRtp === void 0 ? void 0 : lastAudioRtp.packetsReceived) !== undefined) {
        var packetsLost = curAudioRtp.packetsLost - lastAudioRtp.packetsLost;
        var packetsReceived = curAudioRtp.packetsReceived - lastAudioRtp.packetsReceived;
        audioFractionLost = (packetsLost / (packetsLost + packetsReceived)) * 1000; // 3%上报30，计算区间总的丢包率
    }
    // 候选对candidatePair
    var curCandidatePair = curStats.get(candidatePairId);
    var lastCandidatePair = lastStats === null || lastStats === void 0 ? void 0 : lastStats.get(candidatePairId);
    var roundTripTime = 0;
    if ((curCandidatePair === null || curCandidatePair === void 0 ? void 0 : curCandidatePair.totalRoundTripTime) !== undefined &&
        (curCandidatePair === null || curCandidatePair === void 0 ? void 0 : curCandidatePair.responsesReceived) !== undefined &&
        (lastCandidatePair === null || lastCandidatePair === void 0 ? void 0 : lastCandidatePair.totalRoundTripTime) !== undefined &&
        (lastCandidatePair === null || lastCandidatePair === void 0 ? void 0 : lastCandidatePair.responsesReceived) !== undefined) {
        var totalRoundTripTime = curCandidatePair.totalRoundTripTime - lastCandidatePair.totalRoundTripTime;
        var responsesReceived = curCandidatePair.responsesReceived - lastCandidatePair.responsesReceived;
        roundTripTime = (totalRoundTripTime / responsesReceived) * 1000; // 单位秒，换算成毫秒
    }
    return {
        videoPacketsLost: Math.max(videoPacketsLost, 0),
        videoReceiveFps: Math.round(videoReceiveFps),
        videoDecodeFps: Math.round(videoDecodeFps),
        videoBitrate: Number(videoBitrate.toFixed(2)),
        videoFractionLost: Math.max(Number(videoFractionLost.toFixed(2)), 0),
        audioPacketsLost: Math.max(audioPacketsLost, 0),
        audioBitrate: Number(audioBitrate.toFixed(2)),
        audioFractionLost: Math.max(Number(audioFractionLost.toFixed(2)), 0),
        roundTripTime: Math.round(roundTripTime),
    };
};

var updateOpusRestriction = function (sdpText) {
    // 修改offerSdp，启用opus立体声
    var sdpTexts = sdpText
        .split('\r\n')
        .map(function (item) { return (item.includes('a=fmtp:111') ? item + ";stereo=1" : item); });
    return sdpTexts.join('\r\n');
};
var updateSdpForFirefox = function (sdpText) {
    if (!IS_FIREFOX) {
        // 非 firefox 无需修改sdp
        return sdpText;
    }
    // 修改sdp支持firefox拉流播放
    var sdpList = sdpText.split('\r\n');
    var h264List = [];
    var needDeleteList = [];
    sdpList.forEach(function (item) {
        var itemText = item.toLowerCase();
        // a=rtpmap，只保留opus和H264
        // if (itemText.includes('a=rtpmap') && !itemText.includes('opus') && !itemText.includes('h264')) {
        //   needDeleteList.push(item);
        // }
        // a=rtpmap，只保留一个h264
        if (itemText.includes('a=rtpmap') && itemText.includes('h264')) {
            h264List.push(item);
        }
    });
    // 如果有多个h264，只保留一个，删除后面的
    if (h264List.length > 1) {
        needDeleteList.push.apply(needDeleteList, __spreadArray([], __read(h264List.slice(1))));
    }
    // 需要去掉的 playload type
    var playloadTypeList = needDeleteList
        .map(function (item) {
        var result = /a=rtpmap:(\d+)\s/.exec(item);
        return result && result.length > 1 ? result[1] : null;
    })
        .filter(function (item) { return item !== null; });
    // 开始修改sdp
    var resList = [];
    sdpList.forEach(function (item) {
        var res = item;
        // 包含 a=setup 一行都改成 a=setup:passive，启用被动模式
        if (item.includes('a=setup')) {
            res = 'a=setup:passive';
        }
        // 去掉 m=audio 和 m=video 行中的playload type
        if (item.includes('m=audio') || item.includes('m=video')) {
            res = item
                .split(' ') // 空格作为分隔
                .filter(function (value, index) { return index < 3 || !playloadTypeList.includes(value); }) // 从第四段开始为playload type，去掉不需要的
                .join(' '); // 还原成字符串
        }
        // 去掉 a=fmtp 、 a=rtcp-fb 、a=rtpmap 中带playload type的一行
        if (item.includes('a=fmtp') || item.includes('a=rtcp-fb') || item.includes('a=rtpmap')) {
            var result = /a=(?:fmtp|rtcp-fb|rtpmap):(\d+)\s/.exec(item);
            // 先获取playload type，如果在playloadTypeList里面，则去掉这一行
            if (result && result.length > 1 && playloadTypeList.includes(result[1])) {
                return;
            }
        }
        resList.push(res);
    });
    return resList.join('\r\n');
};
var updateSdpRestriction = function (sdpText) {
    var sdpList = sdpText.split('\r\n');
    var h264List = [];
    sdpList.forEach(function (item) {
        var itemText = item.toLowerCase();
        if (itemText.includes('a=rtpmap') && itemText.includes('h264')) {
            h264List.push(item);
        }
    });
    // 获取playload type
    var playloadTypeList = h264List
        .map(function (item) {
        var result = /a=rtpmap:(\d+)\s/.exec(item);
        return result && result.length > 1 ? result[1] : null;
    })
        .filter(function (item) { return item !== null; });
    // 开始修改sdp
    var resList = [];
    sdpList.forEach(function (item) {
        var res = item;
        if (item.includes('a=fmtp:111')) {
            // 启用opus立体声
            res = item + ";stereo=1";
        }
        // 找出a=fmtp中带playload type的一行
        if (item.includes('a=fmtp')) {
            var result = /a=fmtp:(\d+)\s/.exec(item);
            // 先获取playload type，如果在playloadTypeList里面，则修改这一行
            if (result && result.length > 1 && playloadTypeList.includes(result[1])) {
                // 解决某些特定流丢包情况下花屏问题
                res = item + ";sps-pps-idr-in-keyframe=1";
            }
        }
        resList.push(res);
    });
    var newSdpText = resList.join('\r\n');
    // 解决firefox无法播放的问题
    return updateSdpForFirefox(newSdpText);
};

var Logger = /** @class */ (function () {
    function Logger() {
        this.consoleEnabled = false;
    }
    /**
     * 记录log级别日志
     * @param rest 日志内容
     */
    Logger.prototype.log = function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        if (this.consoleEnabled) {
            console.log.apply(console, __spreadArray([], __read(rest)));
        }
    };
    /**
     * 是否允许SDK在控制台上打印Log
     * @param enabled true - 打印，false - 不打印
     */
    Logger.prototype.enableConsole = function (enabled) {
        this.consoleEnabled = enabled;
    };
    return Logger;
}());
var logger = new Logger();

var CloudWebRTC = /** @class */ (function () {
    function CloudWebRTC() {
        this.peerConnection = null;
        this.clientSideDescription = null;
        this.serverSideDescription = null;
        this.connectStatus = ConnectionStatus.DISCONNECTED;
        this.connectDirection = ConnectionDirection.RECEIVE;
        this.negotiating = false; // 当前是否已经进行协商
        this.onAddTrack = null;
        this.onConnect = null;
        this.onDisconnect = null;
        this.onSetLocalDescription = null;
        this.onError = null;
        this.onTrack = this.onTrack.bind(this);
        this.onIceConnectionStateChange = this.onIceConnectionStateChange.bind(this);
        this.onIceCandidate = this.onIceCandidate.bind(this);
        this.onSignalingStateChange = this.onSignalingStateChange.bind(this);
        this.onConnectionStateChange = this.onConnectionStateChange.bind(this);
        this.onNegotiationNeeded = this.onNegotiationNeeded.bind(this);
    }
    CloudWebRTC.prototype.init = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.onAddTrack, onAddTrack = _c === void 0 ? null : _c, _d = _b.onConnect, onConnect = _d === void 0 ? null : _d, _e = _b.onDisconnect, onDisconnect = _e === void 0 ? null : _e, _f = _b.onSetLocalDescription, onSetLocalDescription = _f === void 0 ? null : _f, _g = _b.onError, onError = _g === void 0 ? null : _g;
        this.onAddTrack = onAddTrack;
        this.onConnect = onConnect;
        this.onDisconnect = onDisconnect;
        this.onSetLocalDescription = onSetLocalDescription;
        this.onError = onError;
    };
    CloudWebRTC.prototype.initWebRTCConnect = function (_a) {
        var _b = _a === void 0 ? {} : _a, config = _b.config, _c = _b.direction, direction = _c === void 0 ? ConnectionDirection.RECEIVE : _c, stream = _b.stream;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        logger.log('CloudWebRTC init');
                        if (this.peerConnection) {
                            logger.log('Call disconnected before connect');
                            return [2 /*return*/];
                        }
                        this.connectDirection = direction;
                        return [4 /*yield*/, this.createWebRTCConnect(config, stream)];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CloudWebRTC.prototype.connect = function (description) {
        logger.log('connection connect->', description);
        if (description) {
            this.onAnswer(description);
        }
    };
    CloudWebRTC.prototype.disconnect = function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.msg, msg = _d === void 0 ? '' : _d, _e = _c.code, code = _e === void 0 ? RtcDisconnectCode.MANUAL_CLOSE : _e;
        logger.log('connection disconnect->', code, msg);
        if (this.connectStatus === ConnectionStatus.DISCONNECTED) {
            return;
        }
        this.connectStatus = ConnectionStatus.DISCONNECTED;
        this.negotiating = false;
        // 重置webrtc 连接相关参数
        if (this.peerConnection) {
            this.peerConnection.removeEventListener('track', this.onTrack);
            this.peerConnection.removeEventListener('iceconnectionstatechange', this.onIceConnectionStateChange);
            this.peerConnection.removeEventListener('icecandidate', this.onIceCandidate);
            this.peerConnection.removeEventListener('signalingstatechange', this.onSignalingStateChange);
            this.peerConnection.removeEventListener('connectionstatechange', this.onConnectionStateChange);
            this.peerConnection.removeEventListener('negotiationneeded', this.onNegotiationNeeded);
            this.peerConnection.close();
            this.peerConnection = null;
        }
        this.clientSideDescription = null;
        this.serverSideDescription = null;
        if (code === RtcDisconnectCode.NEED_RECONNECT) {
            logger.log('Please try to reconnect');
        }
        (_b = this.onDisconnect) === null || _b === void 0 ? void 0 : _b.call(this, { code: code, msg: msg });
    };
    CloudWebRTC.prototype.getClientSideDescription = function () {
        if (!this.clientSideDescription) {
            logger.log('webrtc is not initialized');
        }
        return this.clientSideDescription;
    };
    CloudWebRTC.prototype.getConnectStatus = function () {
        return this.connectStatus;
    };
    CloudWebRTC.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.peerConnection) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.peerConnection.getStats(null)];
                    case 1:
                        stats = _a.sent();
                        return [2 /*return*/, stats];
                }
            });
        });
    };
    CloudWebRTC.prototype.createWebRTCConnect = function (config, stream) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var configuration;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        try {
                            configuration = __assign({ iceServers: [], sdpSemantics: 'unified-plan', bundlePolicy: 'max-bundle', rtcpMuxPolicy: 'require', tcpCandidatePolicy: 'disable', IceTransportsType: 'nohost' }, ((_a = config.connection) !== null && _a !== void 0 ? _a : {}));
                            this.peerConnection = new RTCPeerConnection(configuration);
                        }
                        catch (e) {
                            logger.log(e);
                            if (e.name === 'ReferenceError' && e.message.includes('RTCPeerConnection')) {
                                logger.log('Not support WebRTC');
                                (_b = this.onError) === null || _b === void 0 ? void 0 : _b.call(this, 'WebRTC is not supported');
                            }
                            return [2 /*return*/];
                        }
                        this.connectStatus = ConnectionStatus.CONNECTING;
                        this.negotiating = false;
                        this.peerConnection.addEventListener('track', this.onTrack);
                        this.peerConnection.addEventListener('iceconnectionstatechange', this.onIceConnectionStateChange);
                        this.peerConnection.addEventListener('icecandidate', this.onIceCandidate);
                        this.peerConnection.addEventListener('signalingstatechange', this.onSignalingStateChange);
                        this.peerConnection.addEventListener('connectionstatechange', this.onConnectionStateChange);
                        this.peerConnection.addEventListener('negotiationneeded', this.onNegotiationNeeded);
                        if (this.connectDirection === ConnectionDirection.SEND && stream instanceof MediaStream) {
                            // 连接建立之前，先把stream添加到connection上，有助于协商谈判过程，这样创建的offer sdp会包含stream的相关信息
                            stream.getTracks().forEach(function (track) {
                                _this.peerConnection.addTrack(track, stream);
                            });
                        }
                        if (!(this.connectDirection === ConnectionDirection.RECEIVE)) return [3 /*break*/, 2];
                        // 拉流是直接创建offer，推流是先添加track，触发negotiationneeded事件时创建offer
                        return [4 /*yield*/, this.createOffer(config.offer)];
                    case 1:
                        // 拉流是直接创建offer，推流是先添加track，触发negotiationneeded事件时创建offer
                        _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CloudWebRTC.prototype.onTrack = function (event) {
        var _a;
        logger.log('onTrack', event);
        logger.log("on " + event.track.kind + " track", event.streams, event.track);
        (_a = this.onAddTrack) === null || _a === void 0 ? void 0 : _a.call(this, event.track);
    };
    CloudWebRTC.prototype.onIceConnectionStateChange = function (event) {
        logger.log('onIceConnectionStateChange', this.peerConnection.iceConnectionState, event);
        switch (this.peerConnection.iceConnectionState) {
            case 'failed':
            case 'disconnected':
                logger.log('Connection disconnected, please try again');
                this.disconnect({
                    code: RtcDisconnectCode.NEED_RECONNECT,
                    msg: 'Connection disconnected, please try again',
                });
                break;
        }
    };
    CloudWebRTC.prototype.onIceCandidate = function (event) {
        logger.log('onIceCandidate', event);
    };
    CloudWebRTC.prototype.onSignalingStateChange = function (event) {
        logger.log('onSignalingStateChange', this.peerConnection.signalingState, event);
    };
    CloudWebRTC.prototype.onConnectionStateChange = function (event) {
        var _a;
        logger.log('onConnectionStateChange', this.peerConnection.connectionState, event);
        switch (this.peerConnection.connectionState) {
            case 'failed':
            case 'disconnected':
                logger.log('Connection disconnected, please try again');
                this.disconnect({
                    code: RtcDisconnectCode.NEED_RECONNECT,
                    msg: 'Connection disconnected, please try again',
                });
                break;
            case 'connected':
                // 连接建立成功
                logger.log('Connection connected');
                this.connectStatus = ConnectionStatus.ESTABLISHED;
                (_a = this.onConnect) === null || _a === void 0 ? void 0 : _a.call(this, {
                    code: RtcConnectCode.SUCCESS,
                    msg: 'Connection connected',
                });
                break;
        }
    };
    CloudWebRTC.prototype.onNegotiationNeeded = function (event) {
        logger.log('onNegotiationNeeded', event);
        if (this.connectDirection === ConnectionDirection.RECEIVE) {
            return;
        }
        try {
            if (this.negotiating || this.peerConnection.signalingState !== 'stable') {
                return;
            }
            this.negotiating = true;
            this.createOffer();
        }
        catch (error) {
            logger.log('onNegotiationNeeded error', error);
        }
        finally {
            this.negotiating = false;
        }
    };
    CloudWebRTC.prototype.createOffer = function (config) {
        var _a;
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var offerToReceiveVideo, offerToReceiveAudio, otherConfig, offerOptions, isWithAddTransceiver, _b, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        offerToReceiveVideo = config.offerToReceiveVideo, offerToReceiveAudio = config.offerToReceiveAudio, otherConfig = __rest(config, ["offerToReceiveVideo", "offerToReceiveAudio"]);
                        offerOptions = __assign({ voiceActivityDetection: false }, otherConfig);
                        // 只有拉流需要设置，推流不需要
                        if (this.connectDirection === ConnectionDirection.RECEIVE) {
                            isWithAddTransceiver = !!this.peerConnection.addTransceiver;
                            logger.log("peerConnection " + (isWithAddTransceiver ? '' : 'no') + " addTransceiver");
                            if (isWithAddTransceiver) {
                                if (offerToReceiveAudio) {
                                    this.peerConnection.addTransceiver('audio', { direction: 'recvonly' });
                                }
                                if (offerToReceiveVideo) {
                                    this.peerConnection.addTransceiver('video', { direction: 'recvonly' });
                                }
                            }
                            else {
                                offerOptions = __assign(__assign({}, offerOptions), { offerToReceiveVideo: offerToReceiveVideo, offerToReceiveAudio: offerToReceiveAudio });
                            }
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        _b = this.onOffer;
                        return [4 /*yield*/, this.peerConnection.createOffer(offerOptions)];
                    case 2: return [4 /*yield*/, _b.apply(this, [_c.sent()])];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        logger.log('create offer error', error_1);
                        this.disconnect({
                            code: RtcDisconnectCode.NEED_RECONNECT,
                            msg: 'create offer is failed',
                        });
                        (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this, 'create offer is failed');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CloudWebRTC.prototype.onOffer = function (description) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var newSdp, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        logger.log('onOffer->', description);
                        newSdp = description.sdp;
                        if (this.connectDirection === ConnectionDirection.RECEIVE) {
                            // 1、启用opus立体声 2、解决某些流丢包花屏问题 3、支持firefox播放
                            newSdp = updateSdpRestriction(newSdp);
                        }
                        else {
                            // 推流时只需要启用opus立体声
                            newSdp = updateOpusRestriction(newSdp);
                        }
                        // eslint-disable-next-line no-param-reassign
                        description.sdp = newSdp;
                        logger.log('onOffer modify->', description);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.peerConnection.setLocalDescription(description)];
                    case 2:
                        _c.sent();
                        this.clientSideDescription = this.peerConnection.localDescription;
                        (_a = this.onSetLocalDescription) === null || _a === void 0 ? void 0 : _a.call(this, this.clientSideDescription);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _c.sent();
                        logger.log('setLocalDescription error', error_2, this.clientSideDescription);
                        (_b = this.onError) === null || _b === void 0 ? void 0 : _b.call(this, 'set local sdp is failed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CloudWebRTC.prototype.onAnswer = function (description) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.log('onAnswer->', description);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.peerConnection.setRemoteDescription(new RTCSessionDescription(description))];
                    case 2:
                        _b.sent();
                        this.serverSideDescription = this.peerConnection.remoteDescription;
                        logger.log('remoteDescription', this.peerConnection.remoteDescription);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        logger.log('setRemoteDescription error', error_3, description);
                        (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this, 'set remote sdp is failed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return CloudWebRTC;
}());

var Report = /** @class */ (function () {
    function Report() {
        this.timeMark = null;
        this.commonData = null;
        this.reportData = null;
        this.tempData = null;
        this.onReport = null;
        this.timeMark = new Map();
        this.commonData = {};
        this.initCommonData();
        this.reportData = __assign({}, this.commonData);
        this.tempData = {};
    }
    /**
     * 设置统计数据
     * @param key 统计数据字段
     * @param value 统计数据值
     * @param isCommon 是否同步保存到common data
     */
    Report.prototype.setData = function (key, value, isCommon) {
        if (isCommon === void 0) { isCommon = false; }
        this.reportData[key] = value;
        if (isCommon) {
            this.commonData[key] = value;
        }
    };
    /**
     * 临时保存数据，用于后面的数据上报
     */
    Report.prototype.setTempData = function (key, value) {
        this.tempData[key] = value;
    };
    /**
     * 取出临时保存的数据，用于数据计算和上报
     */
    Report.prototype.getTempData = function (key) {
        return this.tempData[key];
    };
    Report.prototype.startReport = function (type) {
        var _a;
        // 数据类型 - 开始拉流和结束拉流是1，区间拉流是2
        // 事件ID - 开始拉流40101，结束拉流40102，区间拉流40100
        switch (type) {
            case 'start':
                this.setData('uint32_data_type', 1);
                this.setData('uint32_command', 40101);
                break;
            case 'interval':
                this.setData('uint32_data_type', 2);
                this.setData('uint32_command', 40100);
                break;
            case 'stop':
                this.setData('uint32_data_type', 1);
                this.setData('uint32_command', 40102);
                break;
        }
        var curTime = new Date().getTime();
        this.setData('uint64_data_time', Math.round(curTime / 1000)); // 数据产生时间
        (_a = this.onReport) === null || _a === void 0 ? void 0 : _a.call(// 数据产生时间
        this, this.reportData);
        // 重置数据，只保留公共数据
        this.reportData = __assign({}, this.commonData);
    };
    /**
     * 设置上报处理函数
     * @param onReport 上报处理函数，用来上报数据
     */
    Report.prototype.setHandler = function (onReport) {
        this.onReport = onReport;
    };
    /**
     * 标记当前时间
     * @param key 标记位名称
     */
    Report.prototype.markTime = function (key) {
        var time = window.performance ? window.performance.now() : new Date().getTime();
        this.timeMark.set(key, time);
    };
    /**
     * 根据开始标记和结束标记，进行一次时间测量，然后作为统计数据保存起来
     * @param key 统计数据字段
     * @param startMark 开始标记位
     * @param endMark 结束标记位
     * @param isTemp 是否临时保存
     */
    Report.prototype.measureTime = function (key, startMark, endMark, isTemp) {
        if (isTemp === void 0) { isTemp = false; }
        if (this.timeMark.has(startMark) && this.timeMark.has(endMark)) {
            var value = Math.round(this.timeMark.get(endMark) - this.timeMark.get(startMark));
            this.setData(key, value);
            if (isTemp) {
                this.setTempData(key, value);
            }
        }
    };
    /**
     * 清理数据
     */
    Report.prototype.clearData = function () {
        if (this.timeMark) {
            this.timeMark.clear();
        }
        else {
            this.timeMark = new Map();
        }
        this.commonData = {};
        this.initCommonData();
        this.reportData = __assign({}, this.commonData);
        this.tempData = {};
    };
    /**
     * 清理内存，销毁数据
     */
    Report.prototype.destroy = function () {
        var _a;
        (_a = this.timeMark) === null || _a === void 0 ? void 0 : _a.clear();
        this.timeMark = null;
        this.commonData = null;
        this.reportData = null;
        this.tempData = null;
        this.onReport = null;
    };
    // 统计可以直接获取的数据，放入commonData
    Report.prototype.initCommonData = function () {
        var userAgent = window.navigator.userAgent;
        var _a = Bowser.parse(userAgent), platform = _a.platform, os = _a.os, browser = _a.browser;
        this.commonData.str_device_type = platform.model || platform.vendor || ''; // 设备型号，如果获取不到设备型号，就填设备厂商
        this.commonData.str_os_info = ((os.name || '') + " " + (os.version || '')).trim(); // 系统版本
        this.commonData.str_browser_model = browser.name || ''; // 浏览器型号
        this.commonData.str_browser_version = browser.version || ''; // 浏览器版本
        this.commonData.str_user_agent = userAgent; // 浏览器userAgent
        this.commonData.u32_link_type = 4;
        this.commonData.u32_channel_type = 3;
    };
    return Report;
}());

var TXLivePlayer = /** @class */ (function () {
    function TXLivePlayer() {
        this.playerView = null;
        this.playUrl = null;
        this.isVideoExisted = false;
        this.webrtcConnection = null;
        this.svrSig = null;
        this.stream = null;
        this.connectRetry = {
            maxNum: CONNECT_RETRY_COUNT,
            curNum: 0,
            delay: CONNECT_RETRY_DELAY, // 重试时延
        };
        this.timeoutId = null;
        this.intervalId = null;
        this.docOrigOverflow = null; // 网页全屏时，保存文档原始的overflow样式
        this.listener = {
            onPlayEvent: null,
            onPlayStats: null,
            onPlayReport: null,
        }; // 事件监听回调函数
        this.lastStatsReport = null; // 保存上一次统计数据
        this.streamEmptyCount = 0; // 统计当前视频流为空的次数
        this.streamDecodeFailCount = 0; // 统计当前视频流解码失败的次数
        this.offerToReceive = {
            // 是否拉取音视频流
            video: true,
            audio: true,
        };
        this.playingStatus = PlayingStatus.INIT; // 播放状态，用于卡顿和卡顿恢复事件
        this.report = null; // 数据统计上报
        this.report = new Report();
        this.onAddTrack = this.onAddTrack.bind(this);
        this.onSetLocalDescription = this.onSetLocalDescription.bind(this);
        this.onConnect = this.onConnect.bind(this);
        this.onDisconnect = this.onDisconnect.bind(this);
        this.onError = this.onError.bind(this);
        this.onStats = this.onStats.bind(this);
        var _a = adapter.browserDetails, browser = _a.browser, version = _a.version;
        logger.log("browser is " + browser + ", version is " + version);
    }
    TXLivePlayer.checkSupport = function (callback) {
        checkSupport().then(function (data) {
            callback === null || callback === void 0 ? void 0 : callback(data);
        });
    };
    TXLivePlayer.prototype.setConfig = function (_a) {
        var connectRetryCount = _a.connectRetryCount, connectRetryDelay = _a.connectRetryDelay, receiveVideo = _a.receiveVideo, receiveAudio = _a.receiveAudio, showLog = _a.showLog;
        if (connectRetryCount !== undefined) {
            if (typeof connectRetryCount === 'number' &&
                connectRetryCount >= 0 &&
                connectRetryCount <= CONNECT_MAX_RETRY_COUNT) {
                this.connectRetry.maxNum = connectRetryCount;
            }
            else {
                logger.log("connectRetryCount must be a number between 0 and " + CONNECT_MAX_RETRY_COUNT);
            }
        }
        if (connectRetryDelay !== undefined) {
            if (typeof connectRetryDelay === 'number' &&
                connectRetryDelay >= 0 &&
                connectRetryDelay <= CONNECT_MAX_RETRY_DELAY) {
                this.connectRetry.delay = connectRetryDelay;
            }
            else {
                logger.log("connectRetryDelay must be a number between 0 and " + CONNECT_MAX_RETRY_DELAY);
            }
        }
        if (receiveVideo !== undefined) {
            this.offerToReceive.video = !!receiveVideo;
        }
        if (receiveAudio !== undefined) {
            this.offerToReceive.audio = !!receiveAudio;
        }
        if (showLog !== undefined) {
            logger.enableConsole(!!showLog);
        }
    };
    TXLivePlayer.prototype.setPlayListener = function (_a) {
        var onPlayEvent = _a.onPlayEvent, onPlayStats = _a.onPlayStats, onPlayReport = _a.onPlayReport;
        if (onPlayEvent !== undefined) {
            if (typeof onPlayEvent === 'function') {
                this.listener.onPlayEvent = onPlayEvent;
            }
            else {
                logger.log('onPlayEvent must be function');
            }
        }
        if (onPlayStats !== undefined) {
            if (typeof onPlayStats === 'function') {
                this.listener.onPlayStats = onPlayStats;
            }
            else {
                logger.log('onPlayStats must be function');
            }
        }
        if (onPlayReport !== undefined) {
            if (typeof onPlayReport === 'function') {
                this.listener.onPlayReport = onPlayReport;
                this.report.setHandler(onPlayReport);
            }
            else {
                logger.log('onPlayReport must be function');
            }
        }
    };
    TXLivePlayer.prototype.setPlayerView = function (container) {
        if (this.playerView) {
            logger.log('player view is existed');
            return;
        }
        var domEl = typeof container === 'string' ? document.getElementById(container) : container;
        if (!domEl || (!(domEl instanceof HTMLDivElement) && !(domEl instanceof HTMLVideoElement))) {
            logger.log('Require container element id or HTMLDivElement');
            return;
        }
        if (domEl instanceof HTMLVideoElement) {
            // tcplayer使用时直接传入video节点，video相关设置由tcplayer完成
            this.playerView = domEl;
            return;
        }
        var videoEl = document.createElement('video');
        videoEl.autoplay = true;
        videoEl.muted = true;
        videoEl.controls = true;
        videoEl.playsInline = true;
        videoEl.setAttribute('webkit-playsinline', '');
        videoEl.setAttribute('x5-playsinline', '');
        videoEl.setAttribute('style', VIDEO_DEFAULT_STYLE);
        domEl.appendChild(videoEl);
        this.playerView = videoEl;
    };
    TXLivePlayer.prototype.startPlay = function (playUrl) {
        // 判断是否支持
        // const supportInfo = await checkSupport();
        // if (!supportInfo.support) {
        //   Logger.log('Not support WebRTC');
        //   return;
        // }
        // 需要先设置播放器元素
        if (!this.playerView) {
            logger.log('Please set player view first');
            return;
        }
        // 先对播放地址进行校验，能够获取流id，说明是正确的webrtc播放地址
        var streamId = getStreamId(playUrl);
        if (streamId === null) {
            logger.log('Play url is not correct');
            return;
        }
        // 判断播放状态
        if (this.isVideoExisted) {
            logger.log('Video is existed, please stop playing first');
            return;
        }
        if (!this.offerToReceive.video && !this.offerToReceive.audio) {
            logger.log('Both receiveVideo and receiveAudio are false');
            return;
        }
        var curTime = new Date().getTime();
        this.report.clearData(); // 拉流开始时，清理之前所有上报保存的数据
        this.report.setData('u64_timestamp', curTime); // 开始拉流时间戳
        this.report.setTempData('pull_start_time', curTime); // 临时保存，用于后续数据上报
        this.report.markTime('pull_start');
        this.report.setData('bytes_stream_id', streamId, true);
        this.report.setData('str_stream_url', playUrl, true);
        this.playUrl = playUrl;
        this.streamEmptyCount = 0;
        this.streamDecodeFailCount = 0;
        this.playingStatus = PlayingStatus.INIT;
        if (!this.webrtcConnection) {
            this.webrtcConnection = new CloudWebRTC();
            // 初始化设置事件监听
            this.webrtcConnection.init({
                onAddTrack: this.onAddTrack,
                onSetLocalDescription: this.onSetLocalDescription,
                onConnect: this.onConnect,
                onDisconnect: this.onDisconnect,
                onError: this.onError,
            });
        }
        this.webrtcConnection.initWebRTCConnect({
            config: {
                connection: {},
                offer: {
                    offerToReceiveVideo: this.offerToReceive.video,
                    offerToReceiveAudio: this.offerToReceive.audio,
                },
            },
        });
    };
    TXLivePlayer.prototype.stopPlay = function (isNeedClearLastImg) {
        var _a, _b, _c;
        if (isNeedClearLastImg === void 0) { isNeedClearLastImg = true; }
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // 判断播放状态
                        if (!this.isVideoExisted) {
                            logger.log('Video is not existed');
                            return [2 /*return*/];
                        }
                        this.isVideoExisted = false;
                        // 如果当前有连接重试，取消重试
                        if (this.timeoutId) {
                            window.clearTimeout(this.timeoutId);
                            this.timeoutId = null;
                            this.connectRetry.curNum = 0;
                        }
                        // 停止数据统计和区间上报
                        if (this.intervalId) {
                            window.clearInterval(this.intervalId);
                            this.intervalId = null;
                        }
                        if (!(this.playUrl && this.svrSig)) return [3 /*break*/, 5];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchStopStream({
                                streamurl: this.playUrl,
                                svrsig: this.svrSig,
                            })];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        logger.log(error_1.message || '');
                        return [3 /*break*/, 4];
                    case 4:
                        this.playUrl = null;
                        this.svrSig = null;
                        _d.label = 5;
                    case 5: return [4 /*yield*/, this.startReport('stop')];
                    case 6:
                        _d.sent();
                        this.webrtcConnection.disconnect();
                        // 停止播放
                        if (isNeedClearLastImg) {
                            (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach(function (track) {
                                track.stop();
                            });
                        }
                        this.stream = null;
                        if (this.playerView) {
                            this.playerView.pause();
                            if (isNeedClearLastImg) {
                                this.playerView.srcObject = null;
                                this.playerView.load();
                            }
                        }
                        (_c = (_b = this.listener).onPlayEvent) === null || _c === void 0 ? void 0 : _c.call(_b, PlayEventCode.PLAY_EVT_PLAY_STOP);
                        return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.isPlaying = function () {
        return this.isVideoExisted && this.isVideoPlaying();
    };
    TXLivePlayer.prototype.pause = function () {
        if (this.playerView && this.isVideoExisted && this.isVideoPlaying()) {
            this.playerView.pause();
        }
    };
    TXLivePlayer.prototype.resume = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.playerView && this.isVideoExisted && !this.isVideoPlaying())) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.playerView.play()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        logger.log('resume failed', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.setMute = function (mute) {
        if (this.playerView) {
            this.playerView.muted = !!mute;
        }
    };
    TXLivePlayer.prototype.setVolume = function (volume) {
        if (typeof volume === 'number' && volume >= 0 && volume <= 100) {
            if (this.playerView) {
                this.playerView.volume = volume / 100;
            }
        }
        else {
            logger.log('volume must be a number between 0 and 100');
        }
    };
    TXLivePlayer.prototype.setControls = function (controls) {
        if (this.playerView) {
            this.playerView.controls = !!controls;
        }
    };
    TXLivePlayer.prototype.setFullscreen = function (fullscreen) {
        if (!this.playerView) {
            return;
        }
        if (fullscreen) {
            this.requestFullscreen();
        }
        else {
            this.exitFullscreen();
        }
    };
    TXLivePlayer.prototype.getVideoElement = function () {
        return this.playerView;
    };
    TXLivePlayer.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.timeoutId) {
                            window.clearTimeout(this.timeoutId);
                            this.timeoutId = null;
                        }
                        if (this.intervalId) {
                            window.clearInterval(this.intervalId);
                            this.intervalId = null;
                        }
                        if (!(this.isVideoExisted && this.webrtcConnection)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.startReport('stop')];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.stream) {
                            this.stream.getTracks().forEach(function (track) {
                                track.stop();
                            });
                            this.stream = null;
                        }
                        if (this.playerView) {
                            this.playerView.pause();
                            this.playerView.srcObject = null;
                            this.playerView.parentElement.removeChild(this.playerView);
                            this.playerView = null;
                        }
                        if (this.webrtcConnection) {
                            this.webrtcConnection.disconnect();
                            this.webrtcConnection = null;
                            this.lastStatsReport = null;
                        }
                        if (this.report) {
                            this.report.destroy();
                            this.report = null;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.isVideoPlaying = function () {
        return !!(this.playerView && this.playerView.paused === false);
    };
    TXLivePlayer.prototype.requestFullscreen = function () {
        // 屏幕全屏为主，网页全屏为辅。全屏模式的优先级为 Fullscreen API > webkitEnterFullScreen > 网页全屏
        var fsApi = FULL_SCREEN_API;
        try {
            if (fsApi.requestFullscreen) {
                // 如果支持 Fullscreen API
                this.playerView[fsApi.requestFullscreen]({ navigationUI: 'hide' });
            }
            else if (supportFullScreen(this.playerView)) {
                // 如果支持 webkitEnterFullScreen
                this.playerView.webkitEnterFullScreen();
            }
            else {
                // 伪全屏，设置css实现网页全屏
                this.enterFullWindow();
            }
        }
        catch (error) {
            logger.log('enter full screen failed, ', error);
        }
    };
    TXLivePlayer.prototype.exitFullscreen = function () {
        var _a;
        var fsApi = FULL_SCREEN_API;
        try {
            if (fsApi.requestFullscreen) {
                // 如果支持 Fullscreen API
                var res = document[fsApi.exitFullscreen]();
                // 如果返回的是Promise对象，通过Promise.catch捕获报错
                (_a = res === null || res === void 0 ? void 0 : res.catch) === null || _a === void 0 ? void 0 : _a.call(res, function (error) { return logger.log('exit full screen failed, ', error === null || error === void 0 ? void 0 : error.message); });
            }
            else if (supportFullScreen(this.playerView)) {
                // 如果支持 webkitEnterFullScreen
                this.playerView.webkitExitFullScreen();
            }
            else {
                // 伪全屏，设置css退出网页全屏
                this.exitFullWindow();
            }
        }
        catch (error) {
            logger.log('exit full screen failed, ', error);
        }
    };
    TXLivePlayer.prototype.enterFullWindow = function () {
        // Storing original doc overflow value to return to when fullscreen is off
        this.docOrigOverflow = document.documentElement.style.overflow;
        // Hide any scroll bars
        document.documentElement.style.overflow = 'hidden';
        // 设置全屏样式
        this.playerView.setAttribute('style', VIDEO_FULLSCREEN_STYLE);
    };
    TXLivePlayer.prototype.exitFullWindow = function () {
        // Unhide scroll bars.
        document.documentElement.style.overflow = this.docOrigOverflow;
        // 移除全屏样式
        this.playerView.setAttribute('style', VIDEO_DEFAULT_STYLE);
    };
    TXLivePlayer.prototype.onAddStream = function (mediaStream) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var onCanplay, iOSVersion, play_1, error_3;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (_b = (_a = this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, PlayEventCode.PLAY_EVT_STREAM_BEGIN);
                        if (!this.playerView) {
                            return [2 /*return*/];
                        }
                        onCanplay = function () {
                            _this.playerView.removeEventListener('canplay', onCanplay);
                            _this.report.markTime('video_play');
                            if (_this.offerToReceive.video) {
                                // 视频渲染时间
                                _this.report.measureTime('u32_first_video_decode_time', 'pull_start', 'video_play');
                                _this.report.measureTime('u32_first_i_frame', 'pull_start', 'video_play', true);
                            }
                            else {
                                _this.report.setData('u32_first_video_decode_time', 0);
                                _this.report.setData('u32_first_i_frame', 0);
                                _this.report.setTempData('u32_first_i_frame', 0);
                            }
                            if (_this.offerToReceive.audio) {
                                // 音频渲染时间
                                _this.report.measureTime('u32_first_audio_render_time', 'pull_start', 'video_play');
                            }
                            else {
                                _this.report.setData('u32_first_audio_render_time', 0);
                            }
                            if (!_this.playerView.autoplay) {
                                // 没有设置自动播放时，直接上报数据
                                _this.startReport('start');
                            }
                        };
                        this.playerView.addEventListener('canplay', onCanplay);
                        this.playerView.srcObject = mediaStream;
                        this.playerView.load();
                        this.isVideoExisted = true;
                        if (!this.playerView.autoplay) {
                            return [2 /*return*/];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.playerView.play()];
                    case 2:
                        _e.sent();
                        iOSVersion = getIOSVersion();
                        if (IS_IOS && iOSVersion.length > 0 && iOSVersion[0] === 13) {
                            // iOS 13.6、13.7会出现画面卡住，声音继续播放的问题，简单规避一下
                            this.playerView.pause();
                            play_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                                var error_4;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _c.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.playerView.play()];
                                        case 1:
                                            _c.sent();
                                            logger.log('play ok ios');
                                            (_b = (_a = this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, PlayEventCode.PLAY_EVT_PLAY_BEGIN);
                                            // 自动播放成功后上报数据
                                            this.startReport('start');
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_4 = _c.sent();
                                            logger.log('play failed', error_4);
                                            this.onPlayError(PlayEventCode.PLAY_ERR_PLAY_FAIL, error_4.toString());
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); };
                            window.setTimeout(function () {
                                play_1();
                            }, 200);
                        }
                        else {
                            logger.log('play ok');
                            (_d = (_c = this.listener).onPlayEvent) === null || _d === void 0 ? void 0 : _d.call(_c, PlayEventCode.PLAY_EVT_PLAY_BEGIN);
                            // 自动播放成功后上报数据
                            this.startReport('start');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _e.sent();
                        // await this.stopPlay();
                        logger.log('play failed', error_3);
                        this.onPlayError(PlayEventCode.PLAY_ERR_PLAY_FAIL, error_3.toString());
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.onAddTrack = function (track) {
        if (track.kind === 'video') {
            this.report.markTime('video_down');
            this.report.measureTime('u32_first_frame_down', 'pull_start', 'video_down');
        }
        else if (track.kind === 'audio') {
            this.report.markTime('audio_down');
            this.report.measureTime('u32_first_audio_frame_down', 'pull_start', 'audio_down');
        }
        if (!this.stream) {
            this.stream = new MediaStream();
            this.stream.addTrack(track);
            this.onAddStream(this.stream);
        }
        else {
            this.stream.addTrack(track);
        }
        logger.log("track length: " + this.stream.getTracks().length);
    };
    TXLivePlayer.prototype.onSetLocalDescription = function (localDescription) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, browser, clientInfo, data, remoteSdp, svrSig, error_5;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, , 6]);
                        sessionId = nanoid();
                        browser = Bowser.parse(window.navigator.userAgent).browser;
                        clientInfo = "TXLivePlayer_" + (browser.name || 'other');
                        (_b = (_a = this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, PlayEventCode.PLAY_EVT_REQUEST_PULL_BEGIN, { localSdp: localDescription });
                        this.report.setData('str_session_id', sessionId, true);
                        this.report.setData('bytes_token', sessionId, true);
                        this.report.markTime('request_start');
                        data = null;
                        if (!this.playUrl.startsWith('webrtc')) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchPullStream({
                                streamurl: this.playUrl,
                                sessionid: sessionId,
                                clientinfo: clientInfo,
                                localsdp: localDescription,
                            })];
                    case 1:
                        // 拉流地址是 webrtc 开头
                        data = _e.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, fetchStreamSdp({
                            streamurl: this.playUrl,
                            sessionid: sessionId,
                            localsdp: localDescription,
                        })];
                    case 3:
                        // 拉流地址是 http/https 开头
                        data = _e.sent();
                        _e.label = 4;
                    case 4:
                        this.report.markTime('request_end');
                        this.report.measureTime('u32_signal_time', 'request_start', 'request_end');
                        remoteSdp = data.remoteSdp, svrSig = data.svrSig;
                        (_d = (_c = this.listener).onPlayEvent) === null || _d === void 0 ? void 0 : _d.call(_c, PlayEventCode.PLAY_EVT_REQUEST_PULL_SUCCESS, { remoteSdp: remoteSdp });
                        this.webrtcConnection.connect(remoteSdp);
                        this.svrSig = svrSig;
                        return [3 /*break*/, 6];
                    case 5:
                        error_5 = _e.sent();
                        logger.log(error_5.message);
                        this.webrtcConnection.disconnect();
                        this.onPlayError(PlayEventCode.PLAY_ERR_REQUEST_PULL_FAIL, error_5.message);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.onConnect = function (response) {
        var _a, _b;
        logger.log('TXLivePlayer onConnect', response);
        // 连接成功
        if (response.code === RtcConnectCode.SUCCESS) {
            this.startStat();
            (_b = (_a = this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, PlayEventCode.PLAY_EVT_SERVER_CONNECTED);
        }
    };
    TXLivePlayer.prototype.onDisconnect = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastStatsReport = null;
                        this.streamEmptyCount = 0;
                        this.streamDecodeFailCount = 0;
                        this.playingStatus = PlayingStatus.INIT;
                        if (this.intervalId) {
                            window.clearInterval(this.intervalId);
                            this.intervalId = null;
                        }
                        logger.log('TXLivePlayer onDisconnect', response);
                        if (!(response.code === RtcDisconnectCode.NEED_RECONNECT)) return [3 /*break*/, 6];
                        if (!(this.playUrl && this.svrSig)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchStopStream({
                                streamurl: this.playUrl,
                                svrsig: this.svrSig,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        logger.log(error_6.message || '');
                        return [3 /*break*/, 4];
                    case 4:
                        this.svrSig = null;
                        _a.label = 5;
                    case 5:
                        if (this.stream) {
                            // 清理stream
                            this.stream.getTracks().forEach(function (track) {
                                track.stop();
                            });
                            this.stream = null;
                        }
                        // 停止播放
                        if (this.isVideoExisted && this.playerView) {
                            this.playerView.pause();
                            this.isVideoExisted = false;
                        }
                        // 开始重试
                        if (this.timeoutId) {
                            window.clearTimeout(this.timeoutId);
                            this.timeoutId = null;
                        }
                        this.timeoutId = window.setTimeout(function () {
                            var _a, _b;
                            _this.connectRetry.curNum += 1;
                            var _c = _this.connectRetry, curNum = _c.curNum, maxNum = _c.maxNum;
                            if (curNum <= maxNum) {
                                logger.log("current retry num: " + curNum + ", max retry num: " + maxNum);
                                (_b = (_a = _this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, PlayEventCode.PLAY_EVT_SERVER_RECONNECT);
                                _this.startPlay(_this.playUrl);
                            }
                            else {
                                _this.onPlayError(PlayEventCode.PLAY_ERR_SERVER_DISCONNECT);
                                // 重置重试次数
                                _this.connectRetry.curNum = 0;
                            }
                            _this.timeoutId = null;
                        }, this.connectRetry.delay * 1000);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.onError = function (errMsg) {
        // WebRTC相关错误
        this.onPlayError(PlayEventCode.PLAY_ERR_WEBRTC_FAIL, errMsg);
    };
    TXLivePlayer.prototype.startStat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats, statCount;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.report.markTime('server_connected');
                        this.report.measureTime('u32_connect_server_time', 'pull_start', 'server_connected');
                        if (this.intervalId) {
                            window.clearInterval(this.intervalId);
                            this.intervalId = null;
                        }
                        return [4 /*yield*/, this.webrtcConnection.getStats()];
                    case 1:
                        stats = _a.sent();
                        if (stats) {
                            this.report.setTempData('start_stats', stats);
                            this.report.setTempData('last_stats', stats);
                            this.report.setTempData('last_time', new Date().getTime());
                            this.onStats(stats);
                        }
                        statCount = 0;
                        this.intervalId = window.setInterval(function () {
                            var _a;
                            (_a = _this.webrtcConnection) === null || _a === void 0 ? void 0 : _a.getStats().then(function (stats) {
                                if (stats) {
                                    // 每秒统计一次webrtc相关的数据
                                    _this.onStats(stats);
                                }
                                statCount += 1;
                                if (statCount % 5 === 0) {
                                    // 每5秒进行一次区间数据上报
                                    _this.startReport('interval');
                                }
                            });
                        }, 1000);
                        return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.onStats = function (stats) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var data = getWebRTCStats(stats, this.lastStatsReport);
        this.lastStatsReport = stats;
        if (data) {
            // firefox下面视频宽高数据不存在，通过video属性去获取
            data.video.frameWidth = data.video.frameWidth || ((_a = this.playerView) === null || _a === void 0 ? void 0 : _a.videoWidth) || undefined;
            data.video.frameHeight = data.video.frameHeight || ((_b = this.playerView) === null || _b === void 0 ? void 0 : _b.videoHeight) || undefined;
            (_d = (_c = this.listener).onPlayStats) === null || _d === void 0 ? void 0 : _d.call(_c, data);
        }
        if ((data === null || data === void 0 ? void 0 : data.video) && this.offerToReceive.video) {
            var _l = data.video, bitrate = _l.bitrate, framesPerSecond = _l.framesPerSecond, framesDecoded = _l.framesDecoded, framesDecodedPerSecond = _l.framesDecodedPerSecond;
            if (bitrate && framesPerSecond) {
                // 前端无法知道直播流是否已经断掉，只能通过码率和帧率来判断；直播流不存在，后台可能还是会建立连接并返回两个空的track，干扰前端的重试逻辑
                this.connectRetry.curNum = 0; // 有数据说明流是真的存在，清空重试次数
            }
            if (!this.isVideoExisted) {
                return;
            }
            // 如果连续5次数据没更新，说明流断了
            if (!bitrate || !framesPerSecond) {
                this.streamEmptyCount += 1;
                if (this.streamEmptyCount >= MAX_STREAM_EMPTY_COUNT) {
                    (_f = (_e = this.listener).onPlayEvent) === null || _f === void 0 ? void 0 : _f.call(_e, PlayEventCode.PLAY_EVT_STREAM_EMPTY);
                    this.streamEmptyCount = 0;
                }
            }
            else {
                this.streamEmptyCount = 0;
            }
            // 如果连续3次，有数据但是解码失败，说明流无法正常解码
            if (bitrate && framesPerSecond && !framesDecoded) {
                this.streamDecodeFailCount += 1;
                if (this.streamDecodeFailCount === MAX_STREAM_DECODE_FAIL_COUNT) {
                    // 解码失败事件只抛出一次
                    this.onPlayError(PlayEventCode.PLAY_ERR_DECODE_FAIL);
                }
            }
            else {
                this.streamDecodeFailCount = 0;
            }
            // 解码帧数小于5帧，说明卡顿（framesPerSecond也作为判断依据）
            if (framesDecodedPerSecond >= 0 || framesPerSecond >= 0) {
                if (framesDecodedPerSecond <= MIN_DECODE_FRAMERATE || framesPerSecond <= MIN_DECODE_FRAMERATE) {
                    var freezeIntervalCount = this.report.getTempData('freeze_interval_count') || 0;
                    this.report.setTempData('freeze_interval_count', freezeIntervalCount + 1); // 区间卡顿次数，当前这一秒处于卡顿状态中，则卡顿次数加1，用于计算区间卡顿率
                    if (this.playingStatus !== PlayingStatus.WAITING) {
                        // 卡顿开始
                        this.playingStatus = PlayingStatus.WAITING;
                        this.report.setTempData('freeze_start_time', new Date().getTime());
                        (_h = (_g = this.listener).onPlayEvent) === null || _h === void 0 ? void 0 : _h.call(_g, PlayEventCode.PLAY_EVT_PLAY_WAITING_BEGIN);
                    }
                }
                else {
                    if (this.playingStatus === PlayingStatus.WAITING) {
                        // 卡顿结束
                        var freezeStartTime = this.report.getTempData('freeze_start_time');
                        var freezeEndTime = new Date().getTime();
                        var time = freezeEndTime - freezeStartTime; // 卡顿时长
                        var videoFreezeData = this.report.getTempData('video_freeze') || {};
                        var _m = videoFreezeData.count, count = _m === void 0 ? 0 : _m, _o = videoFreezeData.totalTime, totalTime = _o === void 0 ? 0 : _o, _p = videoFreezeData.maxTime, maxTime = _p === void 0 ? 0 : _p, _q = videoFreezeData.endTimes, endTimes = _q === void 0 ? [] : _q;
                        count += 1; // 卡顿次数
                        totalTime += time; // 卡顿总时长
                        maxTime = Math.max(time, maxTime); // 卡顿最大时长
                        endTimes = __spreadArray(__spreadArray([], __read(endTimes)), [freezeEndTime]); // 记录所有卡顿结束时间，用于统计区间卡顿次数
                        this.report.setTempData('video_freeze', {
                            count: count,
                            totalTime: totalTime,
                            maxTime: maxTime,
                            endTimes: endTimes,
                        });
                        (_k = (_j = this.listener).onPlayEvent) === null || _k === void 0 ? void 0 : _k.call(_j, PlayEventCode.PLAY_EVT_PLAY_WAITING_STOP);
                    }
                    this.playingStatus = PlayingStatus.PLAYING;
                }
            }
        }
    };
    TXLivePlayer.prototype.startReport = function (type) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var curTime, startTime, firstFrameTime, _c, _d, count, _e, totalTime, _f, maxTime, _g, endTimes, lastTime_1, count, freezeIntervalCount, stats, _h, address, port, startStats, _j, width, height, videoFractionLost, audioFractionLost, framerateMean, lastStats, _k, audioPacketsLost, audioBitrate, audioFractionLost, videoReceiveFps, videoDecodeFps, videoBitrate, videoPacketsLost, videoFractionLost, roundTripTime;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        curTime = new Date().getTime();
                        startTime = this.report.getTempData('pull_start_time');
                        if (type === 'stop') {
                            firstFrameTime = this.report.getTempData('u32_first_i_frame') || 0;
                            this.report.setData('u64_timestamp', curTime); // 结束拉流时间戳
                            this.report.setData('u64_begin_timestamp', startTime); // 开始拉流的时间戳
                            this.report.setData('u32_result', Math.round((curTime - startTime) / 1000)); // 总拉流时长，单位秒
                            this.report.setData('u32_first_i_frame', firstFrameTime); // 首帧时间
                            this.report.setData('u32_first_frame_black', firstFrameTime > 10000 ? 1 : 0); // 首帧是否黑屏，大于10s填1
                            _c = this.report.getTempData('video_freeze') || {}, _d = _c.count, count = _d === void 0 ? 0 : _d, _e = _c.totalTime, totalTime = _e === void 0 ? 0 : _e, _f = _c.maxTime, maxTime = _f === void 0 ? 0 : _f;
                            this.report.setData('u64_block_count', count); // 视频总卡顿次数
                            this.report.setData('u32_video_block_time', totalTime); // 视频总卡顿时间
                            this.report.setData('u64_block_duration_max', maxTime); // 视频最大卡顿时长
                            this.report.setData('u32_avg_block_time', totalTime && count ? Math.round(totalTime / count) : 0); // 视频平均卡顿时长
                        }
                        else if (type === 'interval') {
                            this.report.setData('u64_timestamp', curTime); // 上报时间戳
                            this.report.setData('u64_playtime', curTime - startTime); // 每隔5s累计的拉流时间
                            _g = (this.report.getTempData('video_freeze') || {}).endTimes, endTimes = _g === void 0 ? [] : _g;
                            lastTime_1 = this.report.getTempData('last_time') || 0;
                            count = endTimes.filter(function (time) { return time >= lastTime_1 && time < curTime; }).length;
                            this.report.setData('u32_video_block_count', count);
                            this.report.setTempData('last_time', curTime); // 保存当前时间，用于下一次区间上报
                            freezeIntervalCount = this.report.getTempData('freeze_interval_count') || 0;
                            this.report.setData('u32_block_usage', (freezeIntervalCount / 5) * 1000); // 每5s一次区间上报，计算区间卡顿率
                            this.report.setTempData('freeze_interval_count', 0); // 清空区间卡顿数据
                        }
                        return [4 /*yield*/, this.webrtcConnection.getStats()];
                    case 1:
                        stats = _l.sent();
                        if (stats) {
                            _h = getServerStat(stats), address = _h.address, port = _h.port;
                            this.report.setData('u32_server_ip', "" + address + (port ? ':' : '') + port);
                            if (type === 'stop') {
                                startStats = this.report.getTempData('start_stats');
                                _j = getStopReportStat(stats, startStats), width = _j.width, height = _j.height, videoFractionLost = _j.videoFractionLost, audioFractionLost = _j.audioFractionLost, framerateMean = _j.framerateMean;
                                this.report.setData('u32_video_width', width || ((_a = this.playerView) === null || _a === void 0 ? void 0 : _a.videoWidth)); // 视频宽度
                                this.report.setData('u32_video_height', height || ((_b = this.playerView) === null || _b === void 0 ? void 0 : _b.videoHeight)); // 视频高度
                                this.report.setData('u32_video_drop_usage', videoFractionLost); // 视频丢包率
                                this.report.setData('u32_audio_drop_usage', audioFractionLost); // 音频丢包率
                                this.report.setData('u32_video_avg_fps', framerateMean); // 解码平均帧率
                            }
                            else if (type === 'interval') {
                                lastStats = this.report.getTempData('last_stats');
                                _k = getIntervalReportStat(stats, lastStats), audioPacketsLost = _k.audioPacketsLost, audioBitrate = _k.audioBitrate, audioFractionLost = _k.audioFractionLost, videoReceiveFps = _k.videoReceiveFps, videoDecodeFps = _k.videoDecodeFps, videoBitrate = _k.videoBitrate, videoPacketsLost = _k.videoPacketsLost, videoFractionLost = _k.videoFractionLost, roundTripTime = _k.roundTripTime;
                                this.report.setData('u32_audio_drop', audioPacketsLost); // 音频丢包数
                                this.report.setData('u32_audio_drop_usage', audioFractionLost); // 音频丢包率
                                this.report.setData('u32_avg_audio_bitrate', audioBitrate); // 音频码率
                                this.report.setData('u32_video_drop', videoPacketsLost); // 视频丢包数
                                this.report.setData('u32_video_drop_usage', videoFractionLost); // 视频丢包率
                                this.report.setData('u32_video_recv_fps', videoReceiveFps); // 视频接收帧率
                                this.report.setData('u32_fps', videoDecodeFps); // 视频解码帧率
                                this.report.setData('u32_avg_video_bitrate', videoBitrate); // 视频码率
                                this.report.setData('u32_avg_net_speed', Number((videoBitrate + audioBitrate).toFixed(2))); // 下行速率
                                this.report.setData('u64_rtt', roundTripTime); // 往返rtt
                                this.report.setTempData('last_stats', stats); // 保存当前数据，用于下一次区间上报
                            }
                        }
                        // 数据上报
                        this.report.startReport(type);
                        return [2 /*return*/];
                }
            });
        });
    };
    TXLivePlayer.prototype.onPlayError = function (code, message) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_c) {
                data = message ? { message: message } : undefined;
                (_b = (_a = this.listener).onPlayEvent) === null || _b === void 0 ? void 0 : _b.call(_a, code, data);
                this.report.setData('u64_err_code', code);
                this.report.setData('str_err_info', message || '');
                if (code === PlayEventCode.PLAY_ERR_SERVER_DISCONNECT) {
                    // 重连结束后，结束拉流错误上报
                    this.startReport('stop');
                }
                else {
                    // 开始拉流错误上报
                    this.startReport('start');
                }
                return [2 /*return*/];
            });
        });
    };
    return TXLivePlayer;
}());

export { TXLivePlayer as default };
